export const TRANSLATIONS_ES = {
  CameraErrorPopup: {
    InfoErrors: {
      deviceInUse:
        '<div>No se puede acceder a la cámara. </div><div>Otra aplicación está usando tu cámara. </div><div>Libera la cámara y vuelve a intentarlo.</div>',
      deviceNotFound:
        '<div>No se encontró la cámara. </div><div>Asegúrate de que la cámara esté conectada a tu computadora y funcione correctamente.</div>',
      failedToAccessTheDevice:
        '<div>Ocurrió un error al intentar acceder a la cámara. </div><div>Por favor, vuelve a intentarlo.</div>',
    },
    InfoGuide: {
      android:
        '<ol> <li>Ve a <b>Configuración</b> &gt; <b>Aplicaciones</b> &gt; Elige tu navegador (Chrome, Firefox, etc.).</li> <li>Haz clic en <b>Permisos</b>.</li> <li> Haz clic en <b>Cámara</b> y elige <b>Permitir mientras se usa la aplicación</b> o <b>Preguntar cada vez</b>.</li> </ol>',
      chrome:
        '<ol> <li>Haz clic en el ícono de <b>configuración</b> en la barra de direcciones. </li> <li>Selecciona <b>"Configuración del sitio"</b>.</li> <li>Busca la <b>Cámara</b> y selecciona <b>Permitir</b> en el menú desplegable.</li> </ol>',
      default:
        '<ol> <li>Ve a la configuración del navegador. </li> <li>Enciende la cámara.</li> </ol>',
      edge: '<ol> <li>Haz clic en el ícono de <b>configuración</b> en la barra de direcciones.</li> <li>Elige <b>Permisos</b> para este sitio.</li> <li>Bajo la opción <b>Cámara</b>, selecciona <b>Permitir</b>.</li> </ol>',
      firefox:
        '<ol> <li>Haz clic en el icono de Configuración <b></b> junto a la URL.</li> <li>Haz clic en <b> "Permisos"</b>.</li> <li>Asegúrate de que <b> "Usar la cámara"</b> esté configurado en Permitir.</li> </ol>',
      ios: '<ol> <li>Ve a <b>Configuración</b> > <b>Privacidad y seguridad</b> > <b>Cámara</b>.</li> <li>Activa<b>on</b> el interruptor del navegador que estés usando (por ejemplo, Safari, Chrome).</li> <li> Si Safari te lo pide, haz clic en <b>"Permitir"</b> cuando se te solicite permiso para acceder a la cámara.</li> </ol>',
      safari:
        '<ol> <li>Ve a <b>Safari</b> &gt; <b>Configuración para este sitio web</b>.</li> <li>Junto a <b>Cámara</b>, selecciona <b>Permitir</b>.</li> </ol>',
    },
    description:
      'Para iniciar el video con tu tutor, permite el acceso a la cámara en tu navegador.',
    resolvedBtn: 'Ok, ¡ha sido cambiado!',
    skipBtn: 'Continuar sin cámara',
    title: '¡Queremos verte!',
  },
  ChooseAnotherLevel: 'Elige otro nivel',
  CommunicationProblemModalDescription:
    'Nuestros servidores no responden. Por favor, inténtalo de nuevo. <br />Si el problema persiste, ponte en contacto con nosotros en info@eb.com',
  CommunicationProblemModalTitle: '¡Uy! Tuvimos un problema técnico.',
  GoogleLoginProblemDescription:
    'Para que puedas empezar, primero tu maestro debe registrarte a ti y a tu clase. Cuando tu maestro haya registrado la clase, podrás empezar tu viaje de aprendizaje con Hello.',
  GoogleLoginProblemTitle: '¡Uy! Tuvimos un problema.',
  IAlreadyHaveAnAccount: 'Ya tengo una cuenta',
  MicrophoneInfoErrors: {
    deviceInUse:
      '<div>No es posible acceder al micrófono.</div><div>Otra aplicación está usando tu micrófono.</div><div>Libera el micrófono y vuelve a intentarlo.</div>',
    deviceNotFound:
      '<div>No se ha encontrado un micrófono.</div><div>Asegúrate de que tu micrófono esté conectado a tu computadora y funcione correctamente.</div>',
    failedToAccessTheDevice:
      '<div>Ocurrió un error al intentar acceder al micrófono.</div><div>Por favor, inténtalo de nuevo.</div>',
  },
  MicrophoneInfoGuide: {
    android:
      '<ol> <li>Ve a <b>Configuración</b> &gt; <b>Aplicaciones</b> > Elige tu navegador (Chrome, Firefox, etc.).</li> <li>Haz clic en <b>Permisos</b>.</li> <li>Haz clic en <b>Micrófono</b> y elige <b>Permitir mientras se utiliza la aplicación</b> o <b>Preguntar cada vez</b>.</li> </ol>',
    chrome:
      '<ol> <li>Haz clic en el <b>ícono de configuración</b> en la barra de direcciones.</li> <li>Selecciona <b>"Configuración del sitio"</b>. </li> <li>Busca <b>Micrófono</b> y elige \n <b>Permitir</b> en el menú desplegable.</li> </ol>',
    default:
      '<ol> <li>Ve a la configuración del navegador.</li> <li>Activa el micrófono.</li> </ol>',
    edge: '<ol><li>Haz clic en el <b>ícono de configuración</b> de la barra de direcciones.</li> <li>Elige <b>Permisos</b> para este sitio.</li> <li>En <b>Micrófono</b>, selecciona <b>Permitir</b>.</li></ol>',
    firefox:
      '<ol><li>Haz clic en el <b>ícono de configuración</b> que hay junto a la URL.</li><li>Haz clic en <b>"Permisos"</b>.</li><li>Asegúrate de que <b>"Usar el micrófono"</b> esté configurado en Permitir.</li></ol>',
    ios: '<ol> <li>Ve a <b>Configuración</b> > <b>Privacidad y seguridad</b> > <b>Micrófono</b>. </li> <li><b>Activa</b> el interruptor del navegador que estés usando (por ejemplo, Safari, Chrome).</li> <li>Si se te solicita en Safari, toca <b>"Permitir"</b> cuando se te pida permiso para usar el micrófono.</li>  </ol>',
    safari:
      '<ol> <li>Ve a <b>Safari</b> > <b>Ajustes para este sitio web</b>.</li> <li>Junto a <b>Micrófono</b>, elige <b>Permitir</b>.</li> </ol>',
  },
  MicrophoneInfoInOrderTo:
    'Para algunas de las actividades, necesitarás aprobar el uso del micrófono en tu navegador.',
  MicrophoneInfoInOrderToQuiz:
    'Para esta actividad, deberás permitir el uso del micrófono desde tu navegador.',
  MicrophoneInfoWeWantTo: '¡Queremos escucharte!',
  MinasLoginProblemDescription:
    'Tu cuenta no está autorizada para iniciar sesión con Google. Ponte en contacto con tu maestro o administrador escolar.',
  UnauthorizedLoginProblemDescription:
    'Esta dirección de correo electrónico no está autorizada para el uso de "Hello Britannica". Por favor, comunícate con tu maestro o con la administración de tu escuela.',
  UserNotConfirmedException:
    'Tu cuenta no está verificada. Por favor, ingresa el código de verificación enviado a tu correo electrónico.',
  about: 'Acerca de',
  accountVerifiedCanLoginNow: 'Tu cuenta fue verificada. Ya puedes iniciar sesión.',
  accountVerifiedSigningIn: 'Your account is verified. Signing you in…',
  account_settings: 'Configuración de la cuenta',
  achievmentsSection: {
    feedback: '¡Has demostrado unas habilidades extraordinarias!',
    weeklyAchievement: 'Logro de la semana',
  },
  active: 'Activo',
  activities: 'Actividades',
  addNewClass: 'Añadir nueva clase',
  addYourClasses: 'Agrega tus clases',
  admin: {
    accountDetailsPage: {
      accountIdRequired: 'Se necesita un ID de cuenta para la actualización',
      accountNotFound: 'Cuenta no encontrada.',
      back: 'Volver',
      editAccount: 'Editar cuenta',
      failedToLoad: 'No se pudieron cargar los detalles de la cuenta',
      failedToUpdate: 'No se pudo actualizar la cuenta',
      loadingAccountDetails: 'Cargando detalles de la cuenta...',
    },
    accountInfoCard: {
      accountType: 'Tipo de cuenta',
      brazil: 'Brasil',
      country: 'País',
      createSchoolHint: 'Haz clic aquí para cear una escuela y registrar usuarios en Hello.',
      creationDate: 'Fecha de creación',
      customerPilot: 'Cliente piloto',
      customerProduction: 'Producción del cliente',
      expirationDate: 'Fecha de vencimiento',
      here: 'aquí',
      learningLanguage: 'Idioma de aprendizaje',
      licensesRemaining: 'Licencias restantes',
      loginProvider: 'Provedor de credenciales para iniciar sesión',
      nativeLanguage: 'Idioma nativo',
      no: 'No',
      noOfDistricts: 'Número de distritos',
      noOfSchools: 'Número de escuelas',
      notSet: 'No establecido',
      registeredUsers: 'Usuarios registrados',
      signInOptions: 'Opciones para registrarse',
      systemType: 'Tipo de sistema',
      tutorActive: 'Tutor activo',
      tutorType: 'Tipo de tutor',
      userLimit: 'Límite de usuarios',
      yes: 'Sí',
    },
    accountsListPage: {
      createNewAccount: '+ Crear cuenta nueva',
      newAccount: 'Nueva cuenta',
      title: 'Cuentas',
    },
    bimloaFilter: {
      choose: 'Elegir',
      chooseDate: 'Elegir fecha',
      chooseDateRange: 'Elegir rango de fechas',
      failedToFetchSuggestions: 'No se pudieron obtener sugerencias',
      failedToLoadSuggestions: 'No se pudieron cargar las sugerencias',
      last30Days: 'Últimos 30 días',
      last7Days: 'Últimos 7 días',
      range: 'Intervalo',
      specificDate: 'Fecha específica',
    },
    bulkActions: {
      changeLevel: {
        chooseLevel: {
          description:
            "Change the level of {{count}} students to a new level. <b>Changing students' level will reset their scores and progress. Any previous data will be lost.</b> Note that if students are at different levels, proceeding will set all of them to the new level.",
          hasNonActivedStudentsNote:
            'Note: non-active students will not be affected by the level change.',
          level: 'Level',
          mixedLevelsWarning:
            'ℹ️ The selected students are at different levels. Proceeding will set all of them to {{newLevel}}.',
          selectLevel: 'Select a Level',
          submitButton: 'Confirm Change',
          theNewLevel: 'the new level',
          title: "Change Students' level",
        },
        currentLevel: 'Current Level',
        failure: {
          description: 'Please try again.',
          title: 'No students could be updated.',
        },
        partialSuccesses: {
          description:
            '{{completed}} of {{total}} students have been successfully moved to {{newLevel}}. The following students could not be updated:',
        },
        report: {
          actionChangeLevel: 'Change Level',
          class: 'Class',
          fileName: 'Bulk Change Level Report',
          newLevel: 'New Level',
          previousLevel: 'Previous Level',
        },
        successes: {
          title: 'All {{count}} students have been successfully moved to {{newLevel}}.',
        },
      },
      classes: {
        classesSelected_one: '1 clase seleccionada',
        classesSelected_other: '{{count}} clases seleccionadas',
        deleteClasses_one: 'Borrar clase',
        deleteClasses_other: 'Borrar clases',
      },
      common: {
        action: 'Action',
        classAndGrade: 'Class & Grade',
        failureDescription: 'Please try again later.',
        failureTitle: 'We had a problem',
        name: 'Name',
        partialSuccessTitle: '⚠️ Partial Success',
        teacher: 'Teacher',
      },
      deleteClasses: {
        apiReason: 'Bulk class deletion from school admin',
        confirm: {
          deleteAnywayButton: 'Borrar clases',
          titleWithStudents: '¿Estás seguro?',
          understandWithStudents:
            'Entiendo que estos estudiantes y su progreso serán borrados de manera permanente.',
          warningEmpty:
            '¿Estás seguro de que quieres borrar estas clases? Esta acción no tiene vuelta atrás.',
          warningWithStudents:
            'Estás a punto de borrar {{classCount}} clases, que contienen {{studentCount}} estudiantes seleccionados. Al borrar estas clases, también se borrarán estos estudiantes y serán eliminados de manera permanente de la plataforma. Ya no podrán iniciar sesión y sus datos de progreso se perderán. Una vez confirmada, esta acción no tiene vuelta atrás.',
        },
        partialSuccesses: {
          description: 'Algunas clases no pudieron borrarse. Mira la lista debajo.',
          statusColumn: 'Estado',
          statusDeleted: 'Clases borradas',
          statusFailed: 'No se pudo borrar.',
          studentsDeletedRatio: '{{deleted}}/{{total}}',
          tableStudentsDeleted: 'Estudiantes borrados',
        },
        report: {
          actionDelete: 'Borrar',
          className: 'Nombre de la clase',
          fileName: 'Informe sobre clases borradas en conjunto',
          statusFailure: 'Error',
          statusSuccess: 'Éxito',
        },
        successes: {
          studentsDeletedFollowUpPlural:
            'Además, {{count}} estudiantes fueron borrados correctamente. Se cerraron todas las sesiones activas de los estudiantes borrados y no podrán volver a iniciar sesión.',
          studentsDeletedFollowUpSingular:
            'Además, 1 estudiante fue borrado correctamente. Se cerraron todas las sesiones activas del estudiante borrado y ya no podrá volver a iniciar sesión.',
          title: '¡Las clases seleccionadas se han borrador correctamente!',
        },
      },
      deleteStudents: {
        chooseReason: {
          confirmationCheckbox:
            'Entiendo que estos estudiantes y su progreso serán borrados de forma permanente.',
          description:
            'Estás a punto de borrar a {{num}} estudiantes seleccionados. Al borrarlos, serán eliminados de la plataforma de manera permanente. Ya no podrán iniciar sesión y se perderán todos sus datos de progreso. Una vez confirmada, esta acción no tiene vuelta atrás.',
          reason: 'Motivo',
          subDescription:
            'Esto nos ayuda a conocer las razones por las que los estudiantes se dan de baja de la plataforma.',
          subTitle: 'Por favor, indica un motivo.',
          submitButton: 'Borrar estudiantes',
          title: '¿Estás seguro?',
          why: '¿Por qué?',
        },
        partialSuccesses: {
          description:
            'Los estudiantes borrados han sido desconectados de todas las sesiones activas y no podrán volver a iniciar sesión.',
        },
        report: {
          class: 'Clase',
          fileName: 'Informe sobre estudiantes borrados en conjunto',
        },
        successes: {
          description:
            'Los estudiantes borrados han sido desconectados de todas las sesiones activas y no podrán volver a iniciar sesión.',
          title: '¡Los estudiantes seleccionados fueron borrados correctamente!',
        },
      },
      downloadChanges: {
        downloadButton: 'Descargar',
        text: 'una lista de los cambios',
      },
      moveStudents: {
        availableSeats: {
          description:
            'Has seleccionado {{selectedCount}} estudiantes, pero solo hay {{availableSeats}} lugares disponibles en {{destinationClass}}.\nPor favor, elige una clase diferente o selecciona menos estudiantes.',
          title: '⚠️ Esta clase no tiene suficientes lugares disponibles.',
        },
        chooseDestination: {
          description:
            'Transferir {{num}} estudiantes seleccionados a una nueva clase. Se conservarán el progreso de los estudiantes, el historial de inicio de sesión y sus puntuaciones.',
          full: 'Llena',
          selectClass: 'Selecciona una clase',
          spotsLeft: '{{num}} lugares disponibles',
          subDescription:
            'El progreso de los estudiantes, el historial de inicio de sesión y sus puntuaciones se conservarán durante el traslado.',
          subTitle: 'Elegir destino',
          submitButton: 'Trasladar a los estudiantes',
          title: 'Trasladar estudiantes',
        },
        differentGrade: {
          description:
            'Uno o más de los estudiantes seleccionados ya están asignados a una clase con un grado diferente al de la clase de destino.',
          moveAllButton: 'Trasladar de todos modos',
          moveSameButton: 'Trasladar a todos menos a esos estudiantes',
          title: '⚠️ Algunos estudiantes están en un grado diferente.',
        },
        partialSuccesses: {
          description:
            'Los estudiantes que no pudieron ser trasladados siguen perteneciendo a su clase original. ',
        },
        report: {
          actionMove: 'Trasladar',
          fileName: 'Informe sobre los estudiantes trasladados en conjunto',
          moveFromClass: 'Trasladar de la clase',
          moveFromGrade: 'Trasladar del grado',
          moveFromTeacher: 'Trasladar del maestro',
          moveToClass: 'Trasladar a la clase',
          moveToGrade: 'Trasladar al grado',
          moveToTeacher: 'Trasladar al maestro',
        },
        studentsTable: {
          currentClassAndGrade: 'Clase y grado actuales',
          destinationClassAndGrade: 'Clase y grado de destino',
        },
        successes: {
          description:
            'El progreso de los estudiantes, el historial de inicio de sesión y sus puntuaciones se conservarán.',
          title: '¡Los estudiantes seleccionados fueron trasladados correctamente!',
        },
      },
    },
    changePassword: {
      changePassword: 'Cambiar contraseña',
      confirmPassword: 'Confirmar la contraseña',
      currentPassword: 'Contraseña actual',
      invalidPassword: 'Contraseña inválida',
      newPassword: 'Nueva contraseña',
      password: 'Contraseña',
      passwordsDontMatch: 'Las contraseñas no coinciden',
      reEnterNewPassword: 'Reingresar la nueva contraseña',
      requirements: 'Requisitos:',
    },
    classCodeModal: {
      copyClassCode: 'Copiar código',
      copyClassCodeDescription:
        '¡Copia el código y envíalo a tus estudiantes para que puedan unirse a la plataforma!',
      yourClassCode: 'Tu código de clase:',
    },
    cognitoErrors: {
      NetworkError: 'Error de red. Comprueba tu conexión a internet e inténtalo de nuevo.',
      invalidUsernameOrPassword: 'Correo electrónico o contraseña no válidos',
    },
    collapseSidebar: 'Contraer barra lateral',
    comingSoon: 'Próximamente',
    common: {
      back: 'Volver',
      cancel: 'Cancelar',
      copied: '¡Copiado!',
      loading: 'Cargando...',
      save: 'Guardar',
      saving: 'Guardando...',
      search: 'Buscar',
      tabs: {
        classes: 'Clases',
        general: 'Detalles generales',
        students: 'Estudiantes',
        teachers: 'Maestros',
      },
      tryAgain: 'Try Again',
      tryAgainLater: 'Please try again later.',
    },
    desktopOnlyMessage:
      'To watch your school’s details, reports and dashboards, please use the desktop version.',
    dir: 'ltr',
    districtDetailsPage: {
      back: 'Volver',
      editDistrict: 'Editar distrito',
      info: {
        country: 'País',
        creationDate: 'Fecha de creación',
        email: 'Correo electrónico',
        expirationDate: 'Fecha de vencimiento',
        location: 'Ubicación',
        manager: 'Administrador',
        nativeLanguage: 'Idioma nativo',
        numSchools: 'Número de escuelas',
        numSchoolsHint: 'Al menos una escuela debe estar vinculada para el uso de la plataforma.',
        registeredUsers: 'Usuarios registrados',
      },
      notFound: 'Distrito no encontrado.',
      schoolsTable: {
        addNew: '+ Añadir nuevo distrito',
        columns: {
          contact: 'Contacto',
          school: 'Escuela',
          students: 'Estudiantes',
          teachers: 'Número de maestros',
        },
        title: 'Escuelas',
      },
    },
    districtsListPage: {
      columns: {
        activeUsers: 'Active Users',
        admin: 'Administrador del distrito',
        adminEmail: 'Correo electrónico del administrador del distrito',
        district: 'Distrito',
        registeredUsers: 'Registered Users',
        status: 'Status',
      },
      filters: {
        admin: 'Administrador del distrito',
        adminEmail: 'Correo electrónico del administrador del distrito',
        district: 'Distrito',
        schools: 'Escuelas',
      },
      newDistricts: 'Nuevos distritos',
      title: 'Distritos',
    },
    districtsTable: {
      addNew: '+ Añadir nuevo distrito',
      columns: {
        contact: 'Contacto',
        district: 'Distrito',
        schools: 'Número de escuelas',
        users: 'Usuarios',
      },
      noResults: 'No hay distritos creados en este acuerdo.',
    },
    download: 'Download',
    downloadAndView: 'Download and View',
    dropDown: {
      placeholder: 'Elegir',
    },
    dynamicForm: {
      notification: {
        classCreated: 'La clase fue creada exitosamente.',
        classEdited: 'La clase fue editada exitosamente.',
        generalError: 'Hubo un error. Por favor intenta más tarde',
        schoolNameUpdated: 'El nombre de la escuela fue editado con éxito',
        studentDeleted: 'El estudiante fue borrado con éxito.',
        teacherDeleted: 'La profesora ha sido eliminada con éxito.',
        teacherEdited: 'Los datos del maestro fueron editados exitosamente.',
      },
      popups: {
        changeStatus: {
          cancel: 'No, mantenerlo así',
          confirm: 'Sí, cambiarlo',
          subTitle: '¿Seguro quieres cambiar el estado? Esta acción no puede volverse atrás.',
          title: '¿Cambiar el estado?',
        },
        editSchoolName: {
          Subtitles: 'Ingresa el nombre de la escuela.',
          label: 'Nombre nuevo',
          ok: 'Cambiar nombre',
          title: 'Cambiar el nombre de la escuela',
        },
        newAccount: {
          cancel: 'Cancelar',
          confirm: 'Estoy de acuerdo',
          subTitle:
            'Al crear esta cuenta, aceptas nuestros términos y condiciones para la administración de cuentas y el procesamiento de datos de usuarios.',
          title: 'Términos y condiciones',
        },
        newClassMessage: {
          Subtitles:
            'Se envió un correo electrónico a tus estudiantes con instrucciones para restablecer su contraseña. Una vez que los estudiantes hayan iniciado sesión, recibirán una prueba de nivel. Según los resultados, serán asignados a un nivel apropiado y comenzarán su camino de aprendizaje.',
          title: '¡La clase fue creada con éxito!',
        },
        newRegion: {
          ok: 'Ok',
          subTitle:
            'Se le envió un correo electrónico a %nombre y apellido del administrador regional% con una contraseña provisoria e instrucciones para iniciar sesión %ren HelloHub.',
          title: '%regionName% fue creado con éxito.',
        },
        newTeacherMessage: {
          Subtitles:
            'Se envió un correo electrónico a tus maestros con instrucciones para restablecer su contraseña. Cuando lo hayan hecho, podrán comenzar a usar Hello Britannica.',
          title: '¡Los maestros fueron agregados con éxito!',
        },
        saved: {
          subTitle: '¡Tus cambios se guardaron con éxito!',
          title: '¡Guardado!',
        },
        turnOffDeal: {
          keepOn: 'No, mantenerlo activo',
          subTitle: '¿Seguro quieres desactivar este acuerdo? Esta acción no tiene vuelta atrás.',
          title: '¿Desactivar el acuerdo?',
          turnOff: 'Sí, desactivar',
        },
      },
      validation: {
        email: 'Por favor, ingresa una dirección de correo electrónico válida.',
        invalidFormat: 'This field contains invalid characters.',
        max: 'El valor máximo es {{value}}',
        maxLength: 'La longitud máxima es {{length}}',
        min: 'El valor mínimo es {{value}}',
        minLength: 'La longitud mínima es {{length}}',
        required: 'Este campo es obligatorio',
      },
    },
    error: {
      description:
        'Encontramos un error al procesar tu solicitud. Por favor, vuelve a intentar más tarde.',
    },
    expandSidebar: 'Expand sidebar',
    form: {
      editTeacher: 'Editar maestro',
      email: 'Correo electrónico',
      firstName: 'Nombre',
      lastName: 'Apellido',
    },
    genericTable: {
      classes: {
        activeStudents: 'Estudiantes activos',
        coTeacher: 'Maestro adjunto',
        grade: 'Grado',
        name: 'Nombre de la clase',
        students: 'Estudiantes',
        teacher: 'Nombre del maestro',
      },
      clearSearch: 'Limpiar búsqueda',
      clearSelection: 'Limpiar selección',
      downloadAriaLabel: 'Descargar',
      noRecords: 'No hay registros para mostrar.',
      noResultsForSearchQuery: 'No se encontraron resultados para “{{searchQuery}}”',
      searchDescription_one: 'Se han encontrado {{count}} resultados para “{{searchQuery}}”',
      searchDescription_other: 'Se encontraron {{count}} resultados para “{{searchQuery}}”',
      teachers: {
        activeStudents: 'Estudiantes activos',
        firstLogin: 'Primer inicio de sesión',
        lastLogin: 'Último inicio de sesión',
        name: 'Nombre',
        numClasses: 'Clases',
        numStudents: 'Estudiantes',
      },
    },
    gradeLabel: 'Grado',
    historyPage: {
      dealNameLabel: 'nombre del acuerdo:',
      failedToLoad: 'No se pudieron cargar los datos del historial. Inténtalo de nuevo más tarde.',
      filters: {
        action: 'Acción',
        date: 'Fecha',
        dealName: 'Nombre de la cuenta',
        dealType: 'Tipo de cuenta',
        language: 'Idioma',
        lms: 'Sistema de gestión del aprendizaje (LMS)',
      },
      title: 'Historia',
    },
    instructions: 'Instructions',
    lang: 'inglés',
    loginPage: {
      back: 'Volver',
      changePasswordForm: {
        confirmPassword: 'Confirmar contraseña',
        description: 'Por favor, elige tu propia contraseña',
        errors: {
          confirmPasswordDontMatch: 'Las contraseñas no coinciden',
          confirmPasswordIsRequired: 'Es necesario confirmar la contraseña',
        },
        loadingText: '',
        password: 'Contraseña',
        passwordChangedSuccessfully: 'Contraseña cambiada con éxito',
        passwordPlaceholder: 'Contraseña',
        submit: 'Listo',
        titel: '¡Bienvenido!',
      },
      forgotPasswordForm: {
        confirmPassword: 'Confirmar contraseña',
        description: 'Por favor, ingresa tu información',
        email: 'Correo electrónico',
        emailFieldText:
          'Si la cuenta de correo es válida, recibirás un código de verificación para continuar con el proceso de reestablecer la contraseña.',
        emailPlaceholder: 'ejemplo@correo.com',
        errors: {
          confirmPasswordDontMatch: 'Las contraseñas no coinciden',
          confirmPasswordIsRequired: 'Es necesario confirmar la contraseña',
          emailFormat: 'Correo electrónico no válido',
          emailIsRequired: 'Es necesario ingresar un correo electrónico',
          verificationCodeIsRequired: 'Es necesario ingresar un código',
          verificationCodeMinimumLength: 'El código debe tener al menos 6 dígitos',
        },
        loadingText: '',
        newPassword: 'Ingresar nueva contraseña',
        passwordChangedSuccessfully: 'La contraseña fue cambiada con éxito',
        passwordPlaceholder: 'Tu contraseña aquí',
        sendEmailAgain: '¿No recibiste el código? Envíalo de nuevo.',
        submit: 'Enviar',
        titel: 'Reestablece tu contraseña',
        verificationCode: 'Código de verificación',
        verificationCodePlaceholder: '6 dígitos',
      },
      loginForm: {
        description: 'Por favor, ingresa tu información',
        errors: {
          passwordIsRequired: 'Se requiere una contraseña',
          usernameIsRequired: 'Se requiere un correo electrónico',
        },
        forgotPassword: 'Olvidé la contraseña',
        loadingText: 'Iniciando sesión...',
        password: 'Contraseña',
        submit: 'Iniciar sesión',
        titel: '¡Bienvenido!',
        username: 'Correo electrónico',
      },
      passwordRequirements:
        '<div> <div>Longitud máxima de 8 caracteres</div> <div>Contiene al menos 1 número</div> <div>Contiene al menos 1 letra mayúscula</div> <div>Contiene al menos 1 letra minúscula</div> <div>Contiene al menos 1 caracter especial</div> </div>',
      verificationCodeForm: {
        accountVerified: 'Tu cuenta fue verificada',
        description: 'Ingresar código de verificación',
        errors: {
          verificationCodeIsRequired: 'Se requiere código de verificación',
          verificationCodeMinimumLength: 'El código debe tener al menos 6 dígitos',
        },
        loadingText: 'Iniciando sesión...',
        submit: 'Iniciar sesión',
        titel: '¡Bienvenido!',
        verificationCode: 'Código de verificación',
        verificationCodePlaceholder: 'Ingresar código de verificación',
      },
    },
    pageHeader: {
      edit: 'Editar',
      groupedActiveFiltersSummary: 'Filtros: {{count}}',
    },
    regionsListPage: {
      welcomeMessage:
        'Esta plataforma te permite administrar las regiones para la plataforma <strong>Hello Britannica English Learning</strong>. ¡Adelante! ¡Crea tu primera región!',
      welcomeTitle: '¡Bienvenido, administrador!',
    },
    schoolDetailsPage: {
      classes: {
        actions: {
          addStudent: 'Añadir estudiante',
          delete: 'Borrar',
          downloadReport: 'Descargar informe de clase',
          edit: 'Editar',
          viewClass: 'Ver clase',
        },
        backToClasses: 'Volver a Clases',
        classDeletedSuccessfully: 'La clase fue borrada exitosamente.',
        className: 'Nombre de la clase',
        classNotFound: 'Clase no encontrada',
        continueToUploadingStudents: 'Continúa la carga de estudiantes',
        copyClassCode: 'Código copiado con éxito',
        create: 'Crear',
        deleteClassModal: {
          confirmButton: 'Borrar',
          description:
            'Al borrar esta clase también se borrarán los <strong>{{count}}</strong> estudiantes activos de la clase, incluyendo su progreso e historial. Una vez confirmada, esta acción no tiene vuelta atrás.',
          descriptionEmpty: 'Estás a punto de borrar tu clase. Esta acción no tiene vuelta atrás.',
          descriptionSingular:
            'Al borrar esta clase también se borrará <strong>1</strong> estudiante activo de la clase, incluyendo su progreso e historial. Una vez confirmada, esta acción no tiene vuelta atrás.',
          title: '¿Seguro?',
        },
        deleteTeacherModal: {
          areYouSure: {
            description:
              'El maestro {{teacherName}} tiene {{numberOfStudents}} estudiantes distribuidos en {{numberOfClasses}} clases. ¿Quieres borrar a todos los estudiantes de manera permanente?',
            title: '¿Estás seguro?',
          },
          cancel: 'Cancelar',
          classesWithoutStudents: {
            line: 'Nombre de la clase -<strong>{{name}}</strong> .',
            lineWithClassCode:
              'Nombre de la clase -<strong>{{name}}</strong> y código de la clase -<strong>{{classCode}}</strong>',
            title: 'Las siguientes clases también serán borradas:',
          },
          continue: 'Continuar',
          done: {
            btn: 'Listo',
            deleted0StudentsXClasses: 'Se borraron {{deletedClasses}} clases vacías.',
            deletedNStudentsXClasses:
              'Se borraron {{deletedStudents}} estudiantes y {{deletedClasses}} clases.',
            reassignedTo1Teacher:
              '{{numberOfClasses}} clases y todos los estudiantes asociados a ellas fueron reasignadas al maestro {{teacherName}}.',
            reassignedToNTeachers:
              '{{numberOfClasses}} clases y todos los estudiantes asociados a ellas han sido reasignados a otros maestros.',
            teacherHasBeenRemoved: '{{teacherName}} fue borrado.',
            title: '¡Listo!',
          },
          ok: 'Ok',
          payAttention: {
            description:
              'Estás a punto de borrar a <strong>{{teacherName}}</strong> y todos los datos asociados (clases, estudiantes, progresos de estudiantes y códigos de clases). Esta acción no tiene vuelta atrás.',
            title: '¡Pon atención!',
          },
          selectAction: {
            delete: 'Borrar',
            description:
              'Puedes eliminar la clase o asignarla a otro maestro. Completa los cambios de inscripción de los estudiantes de forma individual antes de borrar al maestro.',
            forAllClasses: 'El mismo maestro para todas las clases',
            keepRemainingTeacher: 'Mantener "{{name}}"',
            moveAllTo: 'Mover todas las clases a:',
            title: 'Por favor, selecciona una acción',
            to: 'Clase "{{name}}" para',
          },
        },
        editClass: 'Editar clase',
        errorLoading: 'Error al cargar clases: {{error}}',
        failedToFetch: 'No se pudieron obtener las clases',
        filters: {
          classCode: 'Código de la clase',
          classCodePlaceholder: 'Buscar código de la clase',
          classSearchPlaceholder: 'Buscar clase',
          gradeSearchPlaceholder: 'Buscar grado',
          teacherSearchPlaceholder: 'Buscar maestro',
        },
        gradeLabel: 'Grado',
        gradeOption1st: '1st',
        gradeOption2nd: '2nd',
        gradeOption3rd: '3rd',
        levelControl: {
          allowIndividualAdvancementLabel: 'Automatic Level Progression',
          allowIndividualAdvancementTooltip:
            'Disabling will stop students in this class who complete a level from automatically continuing to the next level.',
          cancelButton: 'Cancel',
          confirmButton: 'Confirm',
          confirmButtonChangeLevel: 'Change Level',
          confirmButtonDisableLevelProgression: 'Disable Level Progression',
          confirmButtonDisableLevelTest: 'Disable Level Test',
          confirmButtonEnableLevelProgression: 'Enable Level Progression',
          confirmButtonEnableLevelTest: 'Enable Level Test',
          confirmButtonSetLevel: 'Set Level',
          confirmTitle: 'Are you sure?',
          defaultStartingLevelLabel: 'Initial Level',
          defaultStartingLevelPlaceholder: 'Initial Level',
          defaultStartingLevelRequired: 'Please select a default starting level.',
          placementTestRequiredLabel: 'Level Test',
          placementTestRequiredTooltip:
            'Disabling will skip the level placement test for students in this class. You will be required to assign their starting level.',
          warnings: {
            advancementTurnedOff:
              'Turning off automatic level progression means students will stay at their completed level when they finish it. They can repeat activities for more practice.',
            advancementTurnedOn:
              'Turning on automatic level progression means students in this class who have already completed their level will automatically move ahead to the next level on their next login. Any students in this class who complete their level in the future will also move ahead immediately.',
            advancementTurnedOnExistingClass:
              'Turning on automatic level progression means any students who already completed their level will move ahead on their next login. Students who complete their level in the future will also move ahead automatically.',
            advancementTurnedOnNewClass:
              'Turning on automatic level progression means students will move ahead to the next level automatically when they complete their current one.',
            defaultLevelChanged:
              'Changing the class default level will assign the new default to any existing students who have not yet engaged in activities and those who join or are invited to this class in the future. Students in this class who are already engaged will not be affected, and their level might be different than the default. If necessary, you may change existing students’ current level individually or in bulk.',
            defaultLevelChangedExistingClass:
              'This default level will apply to any students who haven’t engaged in activities yet and to any who join this class in the future. Engaged students will not be affected.',
            defaultLevelChangedNewClass:
              'This default level will apply to all students in the class.',
            placementTestTurnedOff:
              'Turning off the level test will assign the class default level to any students who haven’t engaged with any activities yet or who join this class in the future. Students in this class who are already active will not be affected, and their level might be different than the default.',
            placementTestTurnedOffExistingClass:
              'Turning off the level test will assign the class default level to any students who haven’t engaged with any activities yet or who join this class in the future. Engaged students will not be affected.',
            placementTestTurnedOffNewClass:
              'Turning off the level test means all students will be assigned the class default level.',
            placementTestTurnedOn:
              'Turning on the level test will remove the class default level from any students who haven’t engaged with any activities yet. They, and any students who join this class in the future, will need to complete the level test first. Students in this class who are already active will not be affected.',
            placementTestTurnedOnExistingClass:
              'Turning on the level test will remove the class default level from any students who haven’t engaged with any activities yet. They, and any students who join this class in the future, will need to complete the level test first. Engaged students will not be affected.',
            placementTestTurnedOnNewClass:
              'Turning on the level test means all students will need to complete it before starting to engage in activities.',
          },
        },
        newClass: 'Añadir clase',
        placeholderWriteHere: 'Escribe aquí',
        saveClassAndAddLater: 'Guardar y añadir estudiantes más tarde',
        searchPlaceholder: 'Buscar clases',
        teachersLabel: 'Maestros (hasta 2)',
        teachersPlaceholder: 'Elegir',
        teachersSearchPlaceholder: 'Buscar maestro',
        title: 'Clases',
        viewClassPage: {
          addStudents: 'Añadir estudiantes',
          classCodeLabel: 'Código de la clase',
          coTeacher: 'Maestro adjunto',
          editClass: 'Editar clase',
          metaActiveLabel: 'Activos',
          metaInactiveLabel: 'Inactivos',
          metaStudentsLabel: 'Estudiantes',
          studentColumnName: 'Nombre y estado',
          teacher: 'Maestro',
        },
        viewClasses: 'Ver clases',
        zeroState: {
          buttonText: 'Añadir clase',
          description:
            'Crea una clase, añade estudiantes e invítalos a comenzar su camino de aprendizaje del inglés.',
          filterDescription: 'Intenta modificar o restablecer los filtros para ver los datos.',
          filterTitle: 'No hay datos para el período seleccionado.',
          title: '¡Crea tu primera clase!',
        },
      },
      editSchool: 'Editar',
      general: {
        country: 'País',
        expirationDate: 'Fecha de vencimiento',
        licensesUsage: 'Licencias usadas',
        sharedLicenseHint:
          '*El número total de licencias se comparte entre varias escuelas que participan en el mismo acuerdo. El número de licencias disponibles puede variar según el uso que hagan otras escuelas.',
        title: 'Panorama de la escuela',
        totalClasses: 'Número total de clases',
        totalStudents: 'Número total de estudiantes',
        totalTeachers: 'Número total de maestros',
      },
      loadingSchoolDetails: 'Cargando detalles de la escuela...',
      newClassForm: {
        classNamePlaceholder: 'Escribe aquí',
      },
      notFound: 'Escuela no encontrada.',
      students: {
        allLevels: 'Todos los niveles',
        allLevelsHint: 'Los datos reflejan el desempeño de los estudiantes en todos los niveles.',
        changeLevel_one: 'Change Level',
        changeLevel_other: 'Change Level',
        currentLevel: 'Nivel actual',
        deleteStudents_one: 'Borrar estudiante',
        deleteStudents_other: 'Borrar estudiantes',
        displayDataFor: 'Mostrar datos de',
        errorLoading: 'Error al cargar estudiantes: {{error}}',
        failedToFetch: 'No se pudo obtener a los estudiantes',
        moveStudents_one: 'Trasladar estudiante',
        moveStudents_other: 'Trasladar estudiantes',
        searchPlaceholder: 'Buscar estudiantes',
        subTitle: '*El nivel de inicio fue modificado.',
        title: 'Estudiantes',
        titleOnSelected_one: '1 de {{maxNum}} registros seleccionados',
        titleOnSelected_other: '{{num}} de {{maxNum}} registros seleccionados',
        zeroState: {
          description:
            'Una vez que agregues estudiantes, podrás manejarlos desde aquí y ver toda su información en un solo lugar.',
          filterDescription: 'Intenta modificar o restablecer los filtros para ver los datos.',
          filterTitle: 'No hay datos disponibles para los filtros seleccionados.',
          title: '¡Aún no se han inscrito estudiantes en la clase!',
        },
      },
      teachers: {
        addManually: 'Cargar archivo / Añadir a mano',
        copyLink: 'Copiar enlace',
        errorLoading: 'Error al cargar maestros: {{error}}',
        failedToCreate: 'No se pudo crear el maestro',
        failedToFetch: 'No se pudo obtener a los maestros',
        filters: {
          teachers: 'Nombre del maestro',
          teachersSearchPlaceholder: 'Nombre y apellido',
        },
        inviteLinkDescription:
          'Copia y comparte el siguiente enlace para invitar maestros a iniciar sesión.',
        inviteYourTeachers: 'Invitar a tus maestros',
        linkCopied: '¡Enlace copiado!',
        linkCopiedMessage: 'Ahora puedes compartir el enlace con tus maestros.',
        newTeacher: 'Añadir maestro',
        searchPlaceholder: 'Buscar maestros',
        title: 'Maestros',
        zeroState: {
          description: 'Añade a tus maestros, y ellos podrán crear clases y añadir estudiantes.',
          filterDescription: 'Intenta modificar o restablecer los filtros para ver los datos.',
          filterTitle: 'No hay datos disponibles para los filtros seleccionados.',
          title: '¡Inscribe a tus maestros!',
        },
      },
    },
    schoolsListPage: {
      allLevelsHint: 'Los datos reflejan el desempeño de los estudiantes en todos los niveles.',
      classCreated: '¡La clase fue creada con éxito!',
      columns: {
        activeUsers: 'Usuarios activos',
        registeredUsers: 'Usuarios registrados',
        schoolAdmin: 'Administrador de la escuela',
        schoolAdminEmail: 'Correo electrónico del administrador de la escuela',
        schoolName: 'Tipo y nombre de la escuela',
        status: 'Estado',
      },
      createNewSchool: '+ Crear nueva escuela',
      filters: {
        adminEmail: 'Correo electrónico del administrador',
        schoolAdmin: 'Administrador de la escuela',
        schoolType: 'Tipo de escuela',
      },
      newSchool: 'Nueva escuela',
      studentCreatedSuccessfully: '¡Estudiante creado con éxito!',
      studentsCreatedInClass: '¡Los estudiantes fueron creados con éxito en {{className}}!',
      title: 'Escuelas',
    },
    schoolsTable: {
      addNew: '+ Añadir nueva escuela',
      columns: {
        contact: 'Contacto',
        school: 'Escuela',
        students: 'Estudiantes',
        teachers: 'Número de maestros',
      },
      noResults: 'No hay escuelas creadas en este acuerdo.',
    },
    settings: {
      about: 'Acerca de',
      about_me: {
        my_account: 'Mi escuela',
        my_language: 'Mi idioma materno',
        my_name: 'Mi nombre',
        title: 'Sobre mí',
      },
      account_settings: 'Configuración de la cuenta',
      add_students: {
        add_student: 'Añade estudiante',
        classCreatedDescription:
          'Se envió un correo electrónico a tus estudiantes con instrucciones para restablecer su contraseña. Una vez que los estudiantes hayan iniciado sesión, recibirán una prueba de nivel. Según los resultados, serán asignados a un nivel apropiado y comenzarán su camino de aprendizaje.',
        classCreatedDescriptionNoLevelTest:
          'Your students have been emailed instructions for resetting their password. Once your students log in, they will be placed at the default level and may begin their learning journey.',
        create_students:
          'Los siguientes estudiantes recibirán una invitación por correo electrónico:',
        enroll_students: 'Añadir estudiantes',
        enrollment_unsuccessful_description_validation:
          'Los siguientes estudiantes no pudieron ser inscritos por errores de validación:',
        errors: {
          file_empty: 'El archivo que intentas cargar está vacío.',
          first_name_incorrect:
            'Nombre de pila inválido. El nombre contiene caracteres inválidos o es demasiado largo.',
          last_name_incorrect:
            'Apellido inválido. El apellido contiene caracteres inválidos o es demasiado largo.',
          wrong_format:
            'El formato del archivo no es válido. Por favor, asegúrate de estar cargando un archivo de Excel (xlsx).',
        },
        partial_success_description:
          '{{addedStudents}} de {{totalStudents}} estudiantes fueron inscritos exitosamente en esta clase. <br/>Se les envió un correo electrónico con su contraseña temporaria.',
        student_creation_error:
          'Hubo un error al crear al estudiante. Por favor, vuelve a intentar.',
        studentsSuccessfullyEnrolled: 'Los estudiantes fueron registrados exitosamente.',
        upload_file: 'Carga el archivo Excel de tus estudiantes.',
      },
      add_teachers: {
        add_teacher: 'Añadir maestro',
        add_teachers_manually: 'Añadir a mano',
        button_next: 'Siguiente',
        click_to_browse: 'haz clic para navegar',
        create_teacher: 'Crear maestro',
        create_teachers: 'Estos maestros recibirán una invitación por correo electrónico:',
        download: 'Descargar',
        download_sample: 'un archivo de Excel (xlsx) de modelo',
        drag_here: 'Arrastra un archivo aquí o ',
        enroll_teachers: 'Añadir maestros',
        enrollment_unsuccessful: '⚠️ ¡No se pudo añadir al maestro!',
        enrollment_unsuccessful_description:
          'Los siguientes maestros no pudieron ser agregados porque su correo electrónico ya estaba en uso:',
        enrollment_unsuccessful_description_validation:
          'Los siguientes maestros no pudieron ser agregados por errores de validación:',
        errors: {
          bad_formatting:
            'Tu archivo no tiene el formato adecuado. <br/> Por favor, revisa los datos y haz las correcciones necesarias',
          email_in_use: 'Esta dirección de correo electrónico ya está registrada',
          email_incorrect: 'Por favor, ingresa una dirección de correo electrónico válida.',
          file_empty: 'El archivo que intentas cargar está vacío.',
          file_too_large: 'El archivo es demasiado grande. El tamaño máximo permitido es de 256KB.',
          first_name_incorrect:
            'Nombre de pila inválido. El nombre contiene caracteres inválidos o es demasiado largo.',
          first_name_missing: 'El nombre es obligatorio.',
          first_name_too_long: 'Nombre: máximo 30 caracteres.',
          last_name_incorrect:
            'Apellido inválido. El apellido contiene caracteres inválidos o es demasiado largo.',
          last_name_missing: 'El apellido es obligatorio.',
          last_name_too_long: 'Apellido: máximo 40 caracteres.',
          limit_reached:
            'El número máximo es de 50 maestros. <br/> Por favor, borra el archivo y carga uno nuevo.',
          limit_reached_description: 'Tu clase contiene el número máximo de maestros permitidos.',
          limit_reached_title: 'Esta clase ya está llena.',
          max_number_of_teachers:
            'El número máximo es de 50 maestros. <br/> Por favor, borra el archivo y carga uno nuevo.',
          teachers_not_registered: 'Algunos maestros no fueron registrados',
          username_invalid: 'Este nombre de usuario ya está en uso',
          username_missing: 'El nombre de usuario es obligatorio.',
          wrong_format:
            'El formato del archivo no es válido. Por favor, asegúrate de estar cargando un archivo de Excel (xlsx).',
        },
        invite_teachers: 'Invitar maestros',
        not_enough_licenses:
          'Not enough licenses available to complete this operation. {{available}} licenses available, but {{requested}} teachers were requested.',
        partial_success: '⚠️ Éxito parcial',
        partial_success_description:
          '{{addedTeachers}} de {{totalTeachers}} maestros fueron agregados con éxito. <br/>Se les envió un correo electrónico con su contraseña temporaria.',
        register_your_teachers: 'Register Your Teachers',
        success_description:
          'Se envió a los maestros un correo electrónico con instrucciones para restablecer su contraseña.<br/> Una vez que hayan terminado, podrán comenzar a usar Hello Britanica.',
        teacherCreationError: 'No se pudo crear al maestro. Por favor, vuelve a intentar.',
        teacher_creation_error: 'Falló la creación de este maestro. Por favor, vuelve a intentar.',
        teachers_added: '¡Los maestros fueron creados con éxito!',
        upload_attention_text:
          '⚠️ Tu organización tiene {{curent}} /{{limit}} maestros.<br/> Puedes añadir {{certified}} maestros más.',
        upload_attention_text_new_class: '⚠️ Máximo de {{limit}} maestros',
        upload_file: 'Carga el archivo Excel de tus maestros.',
        upload_successful: 'Tu archivo fue cargado exitosamente.',
      },
      delete_class: {
        classNotEmpty: 'No puedes borrar una clase que tiene estudiantes.',
        classNotEmptyDescription:
          'Si quieres borrar esta clase, primero debes borrar esos estudiantes. Puedes hacerlo abriendo el perfil de los estudiantes y haciendo clic en el ícono de Editar.',
      },
      delete_student: {
        tryAgain: 'Vuelve a intentar',
      },
      language_of_study: 'Lengua de estudio',
      native_language: 'Mi idioma nativo',
      passwordRequirements: {
        atLeastOneLowercase: 'Contiene al menos 1 letra minúscula',
        atLeastOneNumber: 'Contiene al menos 1 número',
        atLeastOneSpecial: 'Contiene al menos 1 caracter especial',
        atLeastOneUppercase: 'Contiene al menos 1 letra mayúscula',
        passwordMinimumLength: 'Longitud mínima de 8 caracteres',
      },
      preferences: 'Preferencias',
      school_id: 'Mi escuela',
      suggested_languages: 'Idiomas sugeridos',
    },
    statesListPage: {
      welcomeMessage:
        'Esta plataforma te permite crear y gestionar estados para <strong>Hello Britannica English Learning</strong> Plataforma. ¡Adelante, crea tu primer estado!',
      welcomeTitle: '¡Bienvenido, administrador!',
    },
    statsCardGroup: {
      averageSessionTime: '📊 Tiempo promedio dedicado',
      averageSessionTimeEmpty: 'Los estudiantes no han jugado aún',
      averageSessionTimeTooltip:
        'Tiempo promedio dedicado por los estudiantes a completar actividades',
      engagedStudents: '🟢 Estudiantes comprometidos',
      engagedStudentsEmpty: 'Los estudiantes aún no han completado ninguna actividad',
      engagedStudentsTooltip: 'Estudiantes que han comenzado al menos una actividad',
      engagedTeachers: '🟢 Maestros comprometidos',
      engagedTeachersEmpty: 'Maestros que aún no han creado clases',
      engagedTeachersTooltip: 'Maestros que tienen al menos una clase',
      passiveStudents: '🟢 Estudiantes pasivos',
      passiveStudentsEmpty: 'Aún no se han inscrito estudiantes en la clase',
      passiveStudentsTooltip: 'Estudiantes que aún no han comenzado ninguna actividad',
      totalTimeSpent: 'Tiempo total dedicado',
      totalTimeSpentEmpty: 'Los estudiantos aún no han comenzado actividades',
      totalTimeSpentTooltip:
        'Total de tiempo dedicado por los estudiantes a completar actividades de forma activa',
    },
    studentDataModal: {
      activities: 'Actividades',
      completedLevelNotice:
        "Student has no more new activities. You may manually advance their level if your school's curriculum allows.",
      days: {
        friday: 'Vier',
        monday: 'Lun',
        saturday: 'Sáb',
        sunday: 'Dom',
        thursday: 'Jue',
        tuesday: 'Mar',
        wednesday: 'Mié',
      },
      deleteStudentForm: {
        areYouSure: '¿Seguro?',
        cancel: 'Cancelar',
        choose: 'Elegir',
        close: 'Cerrar',
        delete: 'Borrar',
        deletingFailed: 'No se pudo borrar.',
        deletingFailedDescription:
          'Nuestros servidores no están respondiendo. Por favor inténtalo de nuevo. Si el problema persiste, comunícate con nosotros a <a href="mailto:{{email}}">{{email}}</a>',
        description:
          'Al borrar a este estudiante, se lo eliminará de la plataforma de manera permanente. Este estudiante ya no podrá iniciar sesión y se perderán todos sus datos de progreso. Por favor, indica el motivo:',
        oops: '¡Uy!',
        reason: 'Motivo',
        reasons: {
          aClericalError: 'Un error administrativo',
          other: 'Otro',
          requestedToBeRemoved: 'El estudiante o sus padres pidieron que se lo borrara.',
        },
        tryAgain: 'Vuelve a intentar',
        why: '¿Por qué?',
      },
      editForm: {
        ChooseAnotherLevel: 'Elige otro nivel',
        areYouSure: '¿Seguro?',
        cancel: 'Cancelar',
        changingLevel: '¡Cambiar el nivel del estudiante borrará su progreso y su historial!',
        currentLevel: 'Nivel actual',
        deleteStudent: 'Borrar estudiante',
        edit: 'Editar',
        email: 'Correo electrónico',
        errors: {
          anErrorOccurred: 'Se produjo un error',
          email_incorrect: 'Por favor, ingresa una dirección de correo electrónico válida.',
          first_name_incorrect:
            'Nombre de pila inválido. El nombre contiene caracteres inválidos o es demasiado largo.',
          first_name_missing: 'El nombre es obligatorio.',
          first_name_too_long: 'Nombre: máximo 30 caracteres.',
          last_name_incorrect:
            'Apellido inválido. El apellido tiene caracteres inválidos o es demasiado largo.',
          last_name_missing: 'El apellido es obligatorio.',
          last_name_too_long: 'Apellido: máximo 40 caracteres.',
        },
        firstname: 'Nombre',
        interfaceLanguage: 'Idioma de la interfaz',
        language: 'Idioma',
        lastname: 'Apellido',
        level: 'Nivel',
        save: 'Guardar',
        userDataSuccessfullyUpdated:
          'Los detalles se actualizaron correctamente. Por favor, pide al estudiante que cierre sesión y vuelva a ingresar para ver los cambios.',
        username: 'Nombre de usuario',
        yes: 'Sí',
      },
      firstLogin: 'Primer inicio de sesión',
      interfaceLanguage: 'Idioma de la interfaz',
      level: 'Nivel',
      progress: 'Progreso',
      report: {
        activitiesCompletedInLevel: 'Actividades completadas en el nivel {{level}}',
        allLevelsAvgTime: '📊 Tiempo promedio de todos los niveles',
        attemptsAndHints: 'Intentos y pistas',
        avgAttemptsPerActivity: 'Promedio por actividad',
        avgHintsPerActivity: 'Promedio de pistas por actividad',
        avgPerWeek: 'Promedio por semana',
        avgProgress: 'Progreso promedio',
        avgSkillScores: 'Puntajes por habilidad',
        avgStreakPerWeek: 'Promedio de rachas por semana',
        classDataNotAvailable: 'Los datos de esta clase no están disponibles.',
        continuousEngagement: 'Compromiso continuado',
        date: 'Fecha',
        engagement: 'Compromiso',
        failureRate: 'Tasa de reprobación',
        generateReport: 'Generar informe',
        inCurrentLevel: 'En el nivel actual',
        level: 'Nivel',
        longestStreak: 'Racha más larga',
        overallProgressInLevel: 'Progreso general en el nivel {{level}}',
        passRate: 'Tasa de aprobación',
        previous7Days: 'Últimos 7 días',
        progress: 'Progreso',
        skippedActivitiesComment:
          '* Las actividades omitidas se incluyen en el total de actividades',
        streakLast7Days: 'Racha de los últimos 7 días',
        streakLength: 'Longitud de la racha',
        studentName: 'Nombre del estudiante',
        studentReport: 'Informe del estudiante',
        timeSpentOnActivites: 'Tiempo dedicado a las actividades',
        total: 'Total',
        totalHintsUsed: 'Total de pistas usadas',
        totalInPrev7Days: 'Total en los últimos 7 días',
        tryAgainLater: '¡Vuelve a intentarlo más tarde!',
        weCouldNotProduce: 'El informe no se puede generar en este momento.',
        weStillDontHaveAll: 'Todavía no disponemos de toda la información necesaria.',
      },
      schoolName: 'Nombre de la escuela',
      selfPracticeStreak: 'Racha de práctica autónoma',
      thisStudentIsInactive:
        'Este estudiante está inactivo. Recibió la invitación a la clase, pero aún no ha comenzado la prueba de nivelación inicial.',
      thisStudentIsLevelTestIncomplete:
        'Este estudiante aún no ha completado su prueba de nivelación inicial. Una vez que lo haya hecho, podrás ver su progreso.',
      topics: 'Temas',
      totalProgressWithinLevel: 'Progreso total dentro del nivel',
      unitData: {
        activities: 'Actividades',
        canDo: 'Puedo hacerlo',
        completed: 'Completado',
        failed: 'Reprobado',
        level: 'Nivel',
        skipped: 'Omitidas',
        somethingWentWrong: 'Algo salió mal. Por favor, intenta de nuevo mas tarde.',
        stars: 'Estrellas',
        toggle: 'Alternar',
        topics: 'Temas',
        totalActivities: 'Total de actividades',
      },
      viewPerformance: 'Ver desempeño',
    },
    studentMetricsDashboard: {
      charts: {
        avgStudentGrowth: {
          averageGrowth: 'Average Growth',
          month: 'Mes',
        },
        kpis: {
          averageTimeSpent: {
            tooltip: 'Tiempo promedio dedicado por los estudiantes a completar actividades',
          },
          passRate: {
            tooltip: 'El porcentaje de actividades intentadas que se aprobaron con éxito.',
          },
          totalTimeSpent: {
            tooltip: 'Total de tiempo dedicado por los estudiantes a jugar activamente',
          },
        },
        studentsAcrossSkills: {
          tooltipStudents: 'estudiantes',
        },
      },
      drillDown: {
        students: {
          columns: {
            classNameAndGrade: 'Clase y grado',
            coTeacherName: 'Nombre del maestro adjunto',
            nameAndCoTeacher: 'Nombre y maestro adjunto',
            nameAndTeacher: 'Nombre y maestro',
          },
        },
      },
      emptyState: {
        filter: {
          description: 'Intenta modificar o restablecer los filtros para ver los datos.',
          title: 'No hay datos disponibles para los filtros seleccionados.',
        },
        noStudents: {
          description:
            'Una vez que añadas estudiantes, podrás gestionarlos desde aquí y ver toda su información en un solo lugar.',
          title: '¡Aún no se ha añadido estudiantes!',
        },
      },
      filters: {
        coTeacher: 'Nombre del maestro adjunto',
        fail: 'Reprobado',
        pass: 'Aprobado',
        score: 'Puntuación',
        status: 'Estado',
        statusSearchPlaceholder: 'Buscar estado',
      },
      totalStudents: 'Estudiantes comprometidos: {{totalStudents}}',
    },
    tabbedCard: {
      addNew: '+ Añadir nuevo',
      tabs: {
        districts: 'Distritos',
        schools: 'Escuelas',
      },
    },
    topic: 'Temas',
    university: 'universidad',
    validation: {
      mustBeAtLeastCharacters: 'Este campo debe tener al menos {{length}} caracteres',
    },
  },
  adminInstructions: 'Instrucciones para el administrador',
  again: 'de nuevo',
  all: 'Todos',
  allDone: '¡Ya está!',
  allLevels: 'Todos los niveles',
  almostFinish: '¡Ya falta poco!',
  almostMadeIt: 'Casi lo logras',
  almostThere: 'Ya casi terminas...',
  amazing_job: '¡Excelente trabajo!',
  anErrorOccurred: 'Se ha producido un error...',
  andInviteYourStudents: 'e invite a sus estudiantes',
  andThenInvite: 'y luego invite a sus estudiantes a unirse a ella',
  answerNotAccepted: 'Respuesta no aceptada',
  answeredIncorrectly: 'contestado incorrectamente.',
  appName: 'Hello Britannica',
  appTitle: 'Britannica',
  areYouReadyForTheQuiz: '¿Crees que estás preparado para el juego?',
  areYouSure: '¿Está seguro/a?',
  asSoonAsTheyStart:
    'Una vez que tus estudiantes hayan cambiado sus contraseñas temporarias, ya estarán activos',
  asSoonAsTheyStartGoogle:
    'Tu clase ha sido creada. ¡Ahora debes añadir a tus estudiantes! <br/> Usa el botón de sincronizar para sumar a los estudiantes de tu clase de Google Classroom a la plataforma de "Hello".',
  assessment: 'Evaluación',
  assessments: 'Evaluaciones',
  atLeastOneLowercase: 'Contiene al menos 1 letra minúscula',
  atLeastOneNumber: 'Debe contener al menos 1 número',
  atLeastOneSpecial: 'Debe contener al menos 1 carácter especial',
  atLeastOneUppercase: 'Debe contener al menos 1 letra mayúscula',
  avgAttempts: 'Intentos',
  avgCurrentLevel: 'Nivel actual promedio',
  avgCurrentLevelTooltip: 'El nivel promedio actual de los estudiantes.',
  avgCurrentLevel_mobile: 'Nivel actual promedio',
  avgFailureRate: '❌ Tasa promedio de reprobación',
  avgLevel_mobile: 'Nivel promedio',
  avgPassRate: '✅ Tasa promedio de aprobación',
  avgProgress: 'Progreso promedio',
  avgProgressTooltip: 'El progreso promedio de los estudiantes dentro de su nivel actual.',
  avgProgress_mobile: 'Progreso promedio',
  avgScore: 'Puntaje promedio',
  avgScoreTooltip:
    'El puntaje promedio de los estudiantes en todas las actividades de su nivel actual.',
  avgScore_mobile: 'Puntaje promedio',
  avgTimeSpent: 'Tiempo dedicado',
  avgTimeSpentTooltip:
    'Promedio de todo el tiempo dedicado por los estudiantes a jugar activamente.',
  avgTimeSpent_mobile: 'Tiempo dedicado',
  back: 'Atrás',
  backHome: 'Volver a Inicio',
  backOnline: '¡Parece que estás en línea otra vez!',
  backOnlineActivities: 'Regresemos a las actividades omitidas.',
  bimloaFilter: {
    all: 'Todos',
    close: 'Cerrar',
    filter: 'Filtrar',
    filterBy: 'Filtros',
    max: 'Máximo',
    min: 'Mínimo',
    reset: 'Restablecer',
    resetAll: 'Reestablecer todos',
    to: 'a',
  },
  britannicaEducationWith: 'Britannica Education con',
  byClickingOn:
    'Al hacer clic en el nombre del estudiante, verá su desempeño en cada habilidad y la frecuencia con la que utiliza la aplicación. También puede decidir qué idioma de la interfaz deben utilizar los estudiantes.',
  cameraPermission: {
    button: 'Inténtalo de nuevo',
    text: 'Permiso de cámara denegado. Permite el acceso a la cámara en la configuración de tu navegador.',
  },
  canDo: 'Se puede hacer.',
  cancel: 'Cancelar',
  change_password: 'Cambiar contraseña',
  changingLevel: '¡Cambiar el nivel del estudiante borrará su progreso y su historial!',
  characters: 'Caracteres',
  checkInSpamMessage: '¿No lo has recibido? Revisa tu <0>carpeta de correo no deseado</0>.',
  choose: 'Elegir',
  chooseAvatar: 'Elegir avatar',
  chooseGrade: 'Elegir el grado',
  chooseTheCorrectAnswer: 'Elige la respuesta correcta para completar la oración:',
  chooseUsername: 'Elige un nombre de usuario',
  chooseYourClasses: 'Elige las clases que quieres añadir desde Google Classroom',
  chooseYourFavoriteAvatar: 'Elige tu avatar y color favoritos',
  city: 'Ciudad o distrito',
  class: 'Clase',
  classCode: 'Código de la clase',
  classCodeClassLimitReached: 'Límite de suscripción a clases alcanzado',
  classCodeDealInvalidCode:
    'Código inválido. Por favor, revisa el código que ingresaste o comunícate con tu maestro para obtener un nuevo código.',
  classCodeDealLimitReached: 'Se ha alcanzado el límite de suscripción escolar.',
  classCodeDealNotActive: 'El enlace al que intentas acceder ya ha caducado',
  classCodeDealNotValid:
    'La oferta no es válida. Comprueba el código o ponte en contacto con tu maestro para obtener un nuevo código de clase.',
  classCodeNotActive:
    'El código de clase no está activo. Por favor, comprueba el código o ponte en contacto con tu maestro para obtener un nuevo código de clase.',
  classCreated: '¡La clase ha sido creada con éxito!',
  className: 'Nombre de la clase',
  classReport: 'Informe de clase',
  classWasDeleted: 'Parece que la clase “{{className}}” ha sido borrada desde Google Classroom',
  classWasDeletedDescription:
    'No puedes realizar esta acción hasta que se elimine la clase borrada.',
  classes: 'Clases',
  classesDeleted: '¡La clase fue eliminada correctamente!',
  classesDeletedDescription: 'Ya no tendrás la opción de ver ni editar esta clase.',
  classesImported: '¡Tus clases se importaron!',
  clickHere: '¡Haz clic aquí!',
  close: 'Cerrar',
  closeMenu: 'Cerrar el menú',
  coTeacher: 'Maestro adjunto',
  cognitoErrors: {
    CodeMismatchException: 'El código de verificación provisto no es válido. Vuelve a intentarlo.',
    ExpiredCodeException: 'El código no es válido. Por favor, vuelve a pedir un código.',
    LimitExceededException: 'Se ha superado el límite de intentos. Vuelve a intentarlo más tarde.',
    NetworkError: 'Error de red. Comprueba tu conexión a internet e inténtalo de nuevo.',
    NewPasswordRequiredSessionExpired: 'La sesión ha caducado. Vuelve atrás e inténtalo de nuevo.',
    NotAuthorizedException: 'Correo electrónico o contraseña no válidos',
    UserNotConfirmedException:
      'Tu cuenta no está verificada. Ingresa el código de verificación que recibiste por correo electrónico.',
    UsernameExistsException: 'Este nombre de usuario ya está en uso',
  },
  coins: 'Monedas',
  coinsInstructions: 'Puedes usarlos para obtener ayuda durante los juegos.',
  coinsWillBeLost: 'y todas las monedas que ganaste se perderán.',
  comingSoon: 'Muy<br/>pronto',
  complete: 'Completo',
  completeImportError:
    'Tus clases no pudieron importarse porque ya habían sido importadas por otro maestro.',
  completed: 'Completado',
  completedActivities: 'Total de actividades completadas en este nivel.',
  completedLevelNotice:
    "Student has no more new activities. You may manually advance their level if your school's curriculum allows.",
  confirmPassword: 'Confirmar la contraseña',
  contactAdmin: 'Ponte en contacto con el administrador de tu escuela para que te ayude.',
  contactOurTeam: 'Ponte en contacto con nuestro equipo en',
  contactOurTeamWithQuestions: 'Ponte en contacto con nuestro equipo si tienes preguntas o dudas.',
  contactTeacher: 'Comunícate con tu maestro para obtener una contraseña transitoria.',
  contactUs: 'Contáctanos',
  contactUsSubtitle: 'Nuestro equipo te dará respuestas y orientación.',
  continue: 'Continuar',
  continueOnWeb: 'Continuar en la web',
  continueQuiz: 'Continuar el juego',
  continueToQuestions: 'Continuar con las preguntas',
  continue_level_test: 'Continuar la prueba de nivel',
  copy: 'Copiar',
  copyInvitationLink: 'Copiar enlace de la invitación',
  copyLink: 'Copiar el enlace',
  copyTemporaryPassword: 'Copiar contraseña',
  copyTemporaryPasswordDescription:
    '¡Puedes copiar la contraseña y enviársela a {{firstName}} {{lastname}}!',
  copyright: '2026 Encyclopedia Britannica, Inc.',
  couldNotLocate: 'No pudimos encontrar la página que estás buscando.',
  country: 'País',
  create: 'Crear',
  createClass: 'Añadir clase',
  createClassCode: 'Crear un código de la clase',
  createNewClass: 'Añadir clase',
  createYourClass: 'Cree su clase e invite a sus estudiantes',
  createYourFirstClass: 'Cree su primera clase',
  createYourFirstClassDescription:
    'Crea tu clase y carga la lista de estudiantes que deseas inscribir en esa clase. Luego, invita a tus estudiantes a unirse.',
  currentLevel: 'Nivel actual',
  current_password: 'Contraseña actual',
  customYourLearning: '¡Pronto podremos personalizar tu experiencia de aprendizaje!',
  dashboard: 'Panel de control',
  date: 'Fecha',
  dealLimitReachedMessageAdminDescription:
    'No se pueden añadir más estudiantes. Comunícate con nosotros si necesitas ayuda.',
  dealLimitReachedMessageAdminTitle: 'Se alcanzó el límite de licencias de tu escuela.',
  dealLimitReachedMessageDescription:
    'No se puede añadir más estudiantes. Comunícate con el administrador de tu escuela para que te oriente.',
  dealLimitReachedMessageTitle: 'Se alcanzó el límite de usuarios de tu escuela.',
  dearSchoolAdmin: 'Estimado administrador de la escuela, has sido',
  dearTeacher: 'Estimado maestro, has sido invitado a unirte',
  delete: 'Borrar',
  deleteClass: 'Borrar clase',
  deleteClasses: 'Borrar clases',
  deleteClassesAttention:
    'Ten en cuenta que, en caso de borrar una clase, todos los datos de la clase serán eliminados y no podrán recuperarse. Todo el progreso de los estudiantes se borrará.',
  deleteClassesDescription:
    'Ten en cuenta que, en caso de borrar una clase, todos los datos asociados a la clase se eliminarán y no se podrán recuperar. Se borrará todo el progreso de los estudiantes.',
  dictionary: 'Diccionario',
  didntQuiteHearThat: 'No lo he oído bien.',
  doYouHaveAClassCode: '¿Tienes un código de la clase?',
  doingGreat: 'Lo está haciendo bien.',
  done: 'Listo',
  dontKnow: 'No lo sé',
  downloadAndView: 'Descargar y ver',
  downloadClassReport: 'Descargar informe de la clase',
  downloadList: 'Descargar la lista.',
  edit: 'Editar',
  editClass: 'Editar clase',
  editClassClassNameAlreadyExists: 'Ya existe una clase con este nombre',
  editClassInvalidClassName: 'Se requiere el nombre de la clase',
  editClassInvalidClassNameFormat: 'Class name contains invalid characters.',
  editClassInvalidGrade: 'Calificación requerida',
  editClassInviteNewStudent: 'Añadir nuevos estudiantes',
  editClassStudentFullClassDescription:
    'Tu clase contiene el <br/>número máximo de estudiantes permitidos.',
  editClassStudentFullClassTitle: 'Esta clase ya está llena.',
  editClassStudentNewStudentAddedDescription:
    'Se les ha enviado un correo electrónico con instrucciones para restablecer su contraseña. Una vez que el estudiante inicie sesión en la plataforma, recibirá una prueba de nivel, se lo ubicará en el nivel adecuado y comenzará su aprendizaje.',
  editClassStudentNewStudentAddedTitle: 'ha sido invitado/a!',
  editClassStudentStatus: 'Estado',
  editClassStudentStatusActive: 'Activo/a',
  editClassStudentStatusInactive: 'Inactivo/a',
  email: 'Correo electrónico',
  emailExample: 'correo@gmail.com',
  emailOrUsername: 'Correo electrónico o nombre de usuario',
  emailVerification: 'Verificación del correo electrónico',
  englishLearningJourney: 'viaje de aprendizaje de inglés con Hello Britannica.',
  englishLearningJourneyMorfix: 'viaje de aprendizaje del inglés con Morfixschool 2.0.',
  englishSkillsAssessments: 'Evaluaciones de habilidades de inglés',
  enterCodeHere: 'Ingresa el código aquí',
  enterNewPassword: 'Ingresa la nueva contraseña',
  enterVerificationCode: 'Ingresa el código de verificación',
  enterVerificationCodeAndNewPassword: 'Ingresa el código de verificación y la nueva contraseña',
  enterVerificationCodeHelpText:
    'Ingresa el código que recibiste de tu compañero de recomendación.',
  enterYourAnswerHere: 'Ingresa tu respuesta aquí',
  error: {
    apiMessages: {
      accessDenied: 'Access denied.',
      accessDeniedOrStudentNotFound: 'Access denied or the student is not found.',
      accessDeniedOwnSchoolOnly: 'Access denied - you can only access data from your own school.',
      atLeastOneNameRequired: 'At least one field (first name or last name) must be provided.',
      atLeastOneTeacherRequired: 'At least one teacher must be assigned to the class.',
      atLeastOneUserRequired: 'At least one user is required.',
      classCodeRequired: 'Class code is required.',
      classCodeValidationFailed: 'Failed to process the class code validation response.',
      classReportNotFound: 'Class report not found.',
      dealNotFound: 'Deal not found.',
      dealNotFoundOrInvalid: 'Deal not found or is invalid.',
      dealValidationFailed: 'Deal validation failed.',
      errorCheckingTeacherDeletionEligibility:
        'An error occurred while checking teacher deletion eligibility. Please, try again later.',
      errorCreatingDeal:
        'An error occurred while creating or updating the deal. Please, try again later.',
      errorCreatingGroup: 'An error occurred while creating the group. Please, try again later.',
      errorCreatingPrincipalAdmin:
        'An error occurred while creating the principal admin. Please, try again later.',
      errorDeletingUser: 'An error occurred while deleting the user. Please, try again later.',
      errorProcessingDeletionRequest:
        'An error occurred while processing the deletion request. Please, try again later.',
      errorProcessingTeacherDeletionActions:
        'An error occurred while processing teacher deletion. Please, try again later.',
      errorSigningOut: 'An error occurred while signing out. Please, try again later.',
      errorValidatingClassCode:
        'An error occurred while validating the class code. Please, try again later.',
      errorValidatingDeal: 'An error occurred while validating the deal. Please, try again later.',
      failedToCreateAccount: 'Failed to create the account. Please, try again later.',
      failedToCreateComprehensiveAccount: 'Failed to create the account. Please, try again later.',
      failedToCreateGroup: 'Failed to create a group. Please, try again later.',
      failedToCreateRegion: 'Failed to create region. Please, try again later.',
      failedToCreateStudent: 'Failed to create student. Please, try again later.',
      failedToDeleteGradeConfiguration:
        'Failed to delete grade configuration. Please, try again later.',
      failedToDeleteTeacher: 'Failed to delete teacher. Please, try again later.',
      failedToDeleteTeacherWithActions:
        'Failed to process teacher deletion. Please, try again later.',
      failedToDeleteUser: 'Failed to delete user. Please, try again later.',
      failedToGenerateAdminGuideUrl:
        'Failed to generate the admin guide URL. Please, try again later.',
      failedToProcessUserCreation:
        'Failed to process the user creation request. Please, try again later.',
      failedToRegisterDevice: 'Failed to register the device. Please, try again later.',
      failedToRetrieveDealList: 'Failed to retrieve the deal list.',
      failedToRetrieveRegions: 'Failed to retrieve regions.',
      failedToRetrieveStudentMetrics: 'Failed to retrieve student metrics.',
      failedToRetrieveStudentSkillPerformance: 'Failed to retrieve student skill performance data.',
      failedToRetrieveUserList: 'Failed to retrieve the user list.',
      failedToRetrieveUserStatistics: 'Failed to retrieve user statistics.',
      failedToSaveGradeConfiguration:
        'Failed to save grade configuration. Please, try again later.',
      failedToSetInterfaceLanguage:
        'Failed to set the interface language. Please, try again later.',
      failedToSetStudentSettings: 'Failed to set student settings. Please, try again later.',
      failedToSetUserAvatar: 'Failed to set the user avatar. Please, try again later.',
      failedToSignOut: 'Failed to sign out. Please, try again later.',
      failedToUpdateActivities: 'Failed to update user activities.',
      failedToUpdateGroup: 'Failed to update group. Please, try again later.',
      failedToUpdateTeacher: 'Failed to update teacher. Please, try again later.',
      forbidden: 'Action forbidden.',
      googleUserNotFound: 'Google user not found.',
      gradeConfigurationNotFound: 'Grade configuration not found.',
      groupDeletionFailed: 'Group deletion failed. Please, try again later.',
      groupNotFound: 'Group not found.',
      groupsNotFound: 'Groups not found.',
      groupsReportNotFound: 'Groups report not found.',
      groupsReportTimedOut:
        'The request timed out while retrieving the groups report. Please, try again later.',
      incompleteResponseData: 'The response was successful, but the data was incomplete.',
      incompleteStudentCreationResponse:
        'The response was successful, but the data was incomplete. Students may have been created – please refresh and verify.',
      internalErrorCreatingToken: 'An internal server error occurred while creating the token.',
      invalidAdminManagementResponse: 'Invalid response from the admin management service.',
      invalidDealName: 'Invalid deal name.',
      invalidInputs: 'One or more inputs are invalid.',
      invalidIntsProvided: 'Please enter valid numbers.',
      invalidLevelProvided: 'Invalid level provided.',
      invalidNotificationsResponse: 'Invalid response from the notifications service.',
      invalidOrgOrDeal: 'Invalid request: missing organization details or deal ID.',
      invalidRequest: 'Invalid request.',
      invalidRequestParameters: 'Invalid request parameters.',
      invalidSchoolDealNames:
        'School name, deal name, and school manager names must not contain numbers, and first/last names must not exceed 40 characters.',
      invitationLinkNotFound: 'Invitation link not found.',
      languagePreferencesNotFound: 'Language preferences not found for this school.',
      levelSummariesNotFound: 'Level summaries not found.',
      noDataFound: 'No data found.',
      noDataFoundForIds: 'No data found for the provided IDs.',
      noRegionsFound: 'No regions found.',
      notificationsServiceNotConfigured: 'The notifications service is not configured.',
      operationNotFound: 'Operation not found.',
      organizationDoesNotExist:
        'The organization does not exist. No new users can be registered at this time.',
      ownDevicesOnly: 'You can only register devices for your own account.',
      reportRequestTimedOut:
        'The request timed out while generating the report. Please, try again later.',
      requestBodyRequired: 'Request body is required.',
      requestCanceled: 'The request was cancelled. Please, try again later.',
      requestCanceledRetry: 'The request was cancelled. Please, try again later.',
      requestCannotBeNull: 'The request cannot be empty.',
      requestNotProcessed: 'The request did not process successfully. Please, try again later.',
      schoolAndTeacherIdRequired: 'School ID and Teacher ID are required.',
      schoolIdRequired: 'School ID is required.',
      schoolNotFound: 'School not found.',
      searchQueryRequired: 'Search query is required.',
      studentCreationTimedOut:
        'The request timed out while creating students. The operation may still be processing — please wait a moment and refresh to verify.',
      studentDataNotFoundOrDenied: 'Student data not found or access is denied.',
      studentProgressNotFound: 'Student progress data not found.',
      studentReportNotFound: 'Student report not found.',
      studentRequestRequired: 'The student request cannot be empty.',
      studentsNotFound: 'Students not found.',
      studentsReportNotFound: 'Students report not found.',
      studentsReportTimedOut:
        'The request timed out while retrieving the students report. Please, try again later.',
      teacherDetailsNotFound: 'Teacher details not found.',
      teacherIdRequired: 'Teacher ID is required.',
      teacherNotFound: 'Teacher not found.',
      teachersNotFound: 'Teachers not found.',
      teachersReportNotFound: 'Teachers report not found.',
      teachersReportTimedOut:
        'The request timed out while retrieving the teachers report. Please, try again later.',
      tokenCreationFailed: 'Token creation failed. Please, try again later.',
      unableToParseServerResponse:
        "Unable to parse the server's response. Students may have been created — please refresh and verify.",
      unableToProcessRequest: 'Unable to process your request. Please, try again later.',
      unableToRetrieveGroupsReport:
        'Unable to retrieve the groups report. Please check your request and try again.',
      unableToRetrieveStudentsReport:
        'Unable to retrieve the students report. Please check your request and try again.',
      unableToRetrieveTeachersReport:
        'Unable to retrieve the teachers report. Please check your request and try again.',
      unauthorized: 'Action unauthorized.',
      unexpectedDealServiceResponse: 'Unexpected response from the deal service.',
      unexpectedWithRef:
        'An unexpected error occurred. Please try again or contact support. (Ref: {{ref}})',
      unregisterOwnDevicesOnly: 'You can only unregister your own devices.',
      updateRequestBodyRequired: 'The update request body is required.',
      updatesRequired: 'Updates are required.',
      userAuthContextRequired: 'User authentication context is required.',
      userDoesNotExist: 'The requested user does not exist.',
      userIdentityRequired: 'User identity is required.',
      userNotFound: 'User not found.',
      userOrgDetailsNotFound: 'User organization details not found.',
      userPartiallyDeleted:
        'User deleted only from some systems, but not from all. Please try again or contact support.',
      validTeacherOrgIdRequired: 'A valid Teacher ID and Organization ID are required.',
      verificationCodeInvalid: 'The verification code is invalid.',
    },
    somethingWentWrong: 'Algo salió mal. Vuelve a intentar más tarde, por favor',
    wafBlocked: {
      description:
        'This action has been temporarily blocked for security reasons. Please try again in a few minutes.',
      eyebrow: 'Access Blocked',
      title: 'Oops...',
    },
    weHadAProblem: '¡Uy! Tuvimos un problema.',
  },
  exampleEmail: 'ejemplo@gmail.com',
  exampleSentences: 'Ejemplos de oraciones',
  examples: 'ejemplos',
  exit: 'Salir',
  exploreEngaging:
    'Explora lecciones interesantes y actividades divertidas que harán del aprendizaje del inglés un momento agradable y eficaz.',
  extra: 'Extra',
  extraCoins: 'Monedas extra',
  failed_quiz_message_first: 'No aprobaste esta actividad, así que no hay estrellas.',
  failed_quiz_message_passed:
    'No pasaste esta vez, pero no te preocupes. Tu puntaje anterior ha sido guardado.',
  failureRate: 'Tasa de reprobación',
  fewMoreSeconds: 'solo unos segundos más',
  fieldIsMandatory: 'Este campo es obligatorio',
  filter: 'Filtrar',
  finalAssessment: 'Evaluación final',
  finalEnglishLevelTest: 'Prueba final de nivel de inglés',
  finishActivity: 'Terminar la actividad',
  finishGameText:
    'Has completado el curso de Hello Britannica.<br/> Todas tus actividades quedarán desbloqueadas para que puedas volver atrás y practicar.',
  finishToLevelUp: '¡Termina para subir de nivel!',
  finishUnitSuccessText:
    'Has completado la unidad {{completedUnitName}}. Ya puedes comenzar {{nextUnitName}}. Recuerda que siempre puedes volver a esta unidad para repasar.',
  firstLogin: 'Primer inicio de sesión',
  firstname: 'Nombre',
  focus: 'Encuentra tu flujo',
  for: 'para',
  forgotPassword: 'Olvidé mi contraseña',
  fridayShort: 'vie',
  from: 'De',
  fullVersionAvilableOnlyOnDesktop: 'Versión completa disponible solo en computadora de escritorio',
  generateClassReport: 'Generar informe de clase',
  generateReport: 'Generar informe',
  genericTable: {
    bimloaFilter: {
      all: 'Todos',
      close: 'Cerrar',
      from: 'De:',
      reset: 'Reestablecer',
      resetAll: 'Reestablecer todos',
    },
    dropDown: {
      placeholder: 'Elegir',
    },
    noResultsForSearch: 'No se encontraron resultados para tu búsqueda o filtro.',
  },
  getApp: 'Descargar aplicación',
  getFullExperience: 'Disfruta de la experiencia completa con la aplicación de Hello Britannica',
  getStarted: 'Empezar',
  giveFeedback: 'Contáctanos',
  goAheadAndShareThisLinkWithYourStudentsNow: 'Continúe y comparta este enlace con los estudiantes',
  goBack: 'Regresar',
  goForward: 'Avanzar',
  goToLevelTest: 'Ir a la prueba de nivel',
  go_back_btn: 'Botón Volver',
  goodAfternoon: 'Buenas tardes',
  goodEvening: 'Buenas noches',
  goodJob: '¡Buen trabajo!',
  goodLuck: '¡Buena suerte!',
  goodMorning: 'Buenos días',
  goodNight: 'Buenas noches',
  googleDataAdded: '¡Las clases que elegiste fueron agregadas correctamente!',
  googleDataAddedDescription:
    'Una vez que tus estudiantes inicien sesión en la plataforma, deberán tomar una prueba de nivel. Según los resultados, serán asignados al nivel apropiado para ellos y comenzaran su aventura de aprendizaje.',
  googleDataSynced: '¡Tus datos se han sincronizado!',
  googleDataSyncedDescription:
    'Ahora todos los datos de Google Classroom y Hello están sincronizados.',
  googleStudentIsInactive:
    'Este estudiante está inactivo. Ha recibido la invitación a la clase, pero aún no ha comenzado la prueba de nivelación inicial.',
  googleStudentsAlreadyInOtherGroups:
    'Los siguientes estudiantes no pudieron ser agregados porque ya pertenecen a otra clase:',
  grade: 'Grado',
  grade_1: '1º',
  grade_10: '10º',
  grade_11: '11º',
  grade_12: '12º',
  grade_13: 'Universidad',
  grade_14: 'Ninguno',
  grade_2: '2º',
  grade_3: '3º',
  grade_4: '4º',
  grade_5: '5º',
  grade_6: '6º',
  grade_7: '7º',
  grade_8: '8º',
  grade_9: '9º',
  grade_none: 'Ninguno',
  grade_university: 'Universidad',
  grammar_tip: 'Consejo de gramática',
  great: '¡Estupendo!',
  greatJob: '¡Gran trabajo!',
  guides: 'Guías',
  hello: 'Hola',
  helloBritannica: 'Hello Britannica',
  helloLoader: 'Hola',
  helloTeacher: 'Hola 👋🏻',
  help: 'Ayuda',
  hi: 'Hola',
  hints: 'Pistas',
  hints_options: {
    add_more_time: 'Añadir tiempo al reloj',
    hear_the_english_word: 'Escuchar la palabra en inglés',
    remove_a_letter: 'Eliminar una letra',
    remove_one_answer: 'Eliminar una respuesta',
    reveal_a_pair: 'Revelar un par',
    see_the_translation: 'Ver la traducción',
    see_the_word: 'Ver la palabra',
    show_a_letter: 'Mostrar una letra',
  },
  homepage: 'Página de inicio',
  howDidYouDo: '¿Cómo te fue?',
  howsYourEnglish: '¿Cómo va tu inglés?',
  iAgree: 'Estoy de acuerdo',
  iAgreeTo: 'Estoy de acuerdo con los',
  iAmReady: '¡Estoy listo!',
  iDidntUnderstand: 'No entendí. Inténtalo nuevamente.',
  iDoNotAgree: 'No estoy de acuerdo',
  id: 'Identificación',
  illDoItLater: 'Lo haré más tarde',
  importClasses: 'Importar clase',
  importYourFirstClass: '¡Importa tu primera clase desde Google Classroom!',
  importYourFirstClassDescription:
    'Importa tu clase de Google Classroom a Hello. Luego tus estudiants podrán unirse.',
  improveYourLastActivities: 'Mejora tus últimas actividades.',
  in_order_to_start: 'Para comenzar tu viaje de aprendizaje, necesitamos',
  inactive: 'Inactivo',
  incorrect: '¡Incorrecto!',
  incorrect_answer: 'incorrecto.',
  initialLevelTest: 'Prueba de nivel inicial',
  interfaceLanguage: 'Idioma de la interfaz',
  interface_language: 'Idioma de la interfaz',
  invalidCode: 'Código no válido',
  invalidEmail: 'Correo electrónico no válido',
  invalidEmailOrUsername: 'Correo electrónico o nombre de usuario no válido',
  invalidField: 'Campo no válido',
  invalidFirstname: 'Nombre no válido',
  invalidLastname: 'Apellido no válido',
  invalidOrganizationName: 'School name contains invalid characters.',
  invalidPassword: 'Contraseña no válida.',
  invalidUsername:
    'El nombre de usuario debe contener letras, números y estos símbolos: . _  - No se permiten espacios. Máximo 20 caracteres',
  invalidUsernameOrPassword: 'Nombre de usuario o contraseña no válidos',
  invalidUsernameinForgotPassword:
    'Algo salió mal con el nombre de usuario "{{username}}". Por favor, ponte en contacto con tu maestro para obtener más ayuda.',
  invitationLink: 'Enlace de invitación',
  invitationLinkWontChange: 'No te preocupes, el enlace de invitación no cambiará',
  inviteYourStudents: 'Invite a sus estudiantes',
  inviteYourTeachers: 'Invita a tus profesores a unirse a ',
  invitedToJoin: 'invitado/a a unirse a Hello Britannica.',
  invitedToJoinMorfix: 'invitado/a a unirse a Morfixschool 2.0',
  isNotEnglish:
    'Para esta actividad, es necesario que escribas en inglés. Por favor, vuelve a intentarlo.',
  itLooksLikeYourLevel:
    'Parece que el Nivel {{level}} es el más adecuado por ahora. ¡Sigue practicando y seguirás mejorando!',
  itLooksLikeYourLevelMax:
    '¡Muy buen trabajo! Parece que el Nivel {{level}} es el apropiado para ti. ¡Comencemos!',
  itsTime: 'Es hora de elegir si estás preparado para el juego o no,',
  joinNow: 'Únete ahora',
  keepGoing: '¡Sigue adelante!',
  keepPlaying: '¡Sigue jugando!',
  keepPracticing: 'Sigue practicando.',
  know: 'Lo sé',
  know_your_level: 'saber tu nivel de inglés.',
  language: 'Idioma',
  language_of_study: 'Idioma de estudio',
  languages: {
    ar: 'Árabe',
    en: 'Inglés',
    es: 'Español',
    he: 'Hebreo',
    pt: 'Portugués',
  },
  lastLogin: 'Último inicio de sesión',
  lastUncorrectPronounce: 'Pasar a la siguiente pregunta.',
  lastUnitCongratulation:
    'Has completado el nivel <strong>{{currentLevel.name}}</strong><br/> y estás en camino al nivel <strong>{{nextLevel.name}}</strong>.',
  lastname: 'Apellido',
  learn: '{{lessons}} lecciones disponibles',
  leave_level_test_and_sign_out: '¿Dejar la prueba de nivel?',
  letsAssess:
    'Vamos a comprobar tu nivel de inglés con un breve cuestionario. De esa forma, podemos ofrecerte la mejor experiencia de aprendizaje. Puede tardar entre 5 y 15 minutos según su rendimiento. ¿Estás listo?',
  letsBegin: 'Comencemos',
  letsFinish: 'Terminemos',
  letsGo: 'Vamos',
  letsKeepLearning: '¡sigamos aprendiendo!',
  letsSee: 'Veamos qué tan bien conoces tu vocabulario.',
  level: 'Nivel',
  levelChanged: 'Tu nivel ha cambiado.',
  levelChangedDescription:
    'Ten en cuenta que tu progreso y actividad anteriores se han borrado para reflejar tu nueva ruta de aprendizaje.',
  levelChangedDown: 'Tu maestro ha ajustado tu nivel de aprendizaje.',
  levelChangedDownDescription:
    'Esto es para ayudarte a fortalecer tus habilidades esenciales antes de avanzar. ¡Puedes hacerlo!',
  levelChangedUp: 'Tu maestro te ha ascendido a un nivel más alto de aprendizaje.',
  levelChangedUpDescription: '¡Continúa con tu gran trabajo y sigue desafiándote a ti mismo!',
  levelName_1: 'Starter (Pre-A1)',
  levelName_2: 'Beginner (A1)',
  levelName_3: 'Pre-Intermediate (A2)',
  levelName_4: 'Intermediate (B1)',
  levelName_5: 'Upper Intermediate (B2)',
  levelName_6: 'Advanced (C1)',
  levelTest: 'Prueba de nivel',
  levelTestIncomplete: 'Prueba de nivel incompleta',
  levelTestPausedDescription:
    'Las últimas {{count}} pregunas no se guardarán y deberás volver a repetirlas.',
  level_test: 'Prueba de nivel',
  linkCopied: '¡Enlace copiado!',
  listen_tip: 'Consejo de escuchar',
  listeningTapToFinish: 'Haz clic para enviar',
  loginFromDifferent: 'Iniciar sesión desde otra cuenta',
  logout: 'Cerrar sesión',
  longClassName: 'El nombre de la clase puede tener hasta 40 caracteres.',
  melingoCalculateYourLevel: 'Estamos calculando tu nivel...',
  memoryGameTitle:
    'Da la vuelta a las tarjetas para encontrar seis coincidencias entre textos e imágenes.',
  menu_button: 'Botón de menú',
  message: 'Mensaje',
  mgWebsite: {
    loginFormButton: 'Continuar con Google',
    loginFormSubTitle:
      ' <div>Haz clic a continuación para iniciar sesión con tu </div> <div>Cuenta de Google: ¡es rápido, fácil y seguro!</div> ',
    loginFormTitle: '¡Hola! ¡Qué bueno verte!',
  },
  microphoneRestricted: 'El acceso al micrófono está restringido en tu computadora.',
  missingGooglePermissionsPopup: {
    button: 'Actualizar permisos',
    description: 'Luego de tu aprobación, ¡podrás comenzar tu viaje con Hello!',
    title: 'Por favor, permítele el acceso a "Hello"',
  },
  mondayShort: 'lun',
  months: {
    apr: 'Abr',
    aug: 'Ago',
    dec: 'Dic',
    feb: 'Feb',
    jan: 'Ene',
    jul: 'Jul',
    jun: 'Jun',
    mar: 'Mar',
    may: 'May',
    nov: 'Nov',
    oct: 'Oct',
    sep: 'Sep',
  },
  multiSelectDropDown: {
    loadMore: 'Cargar más',
    loading: 'Cargando...',
    noResults: 'No se encontraron resultados',
    removeAll: 'Eliminar todos',
    selected: 'seleccionado',
    typeText: 'Escribe texto para buscar datos',
  },
  myPrivateTutor: 'Mi instructor privado',
  myProfile: 'Mi perfil',
  myProgress: 'Mi progreso',
  myProgressCompletedNotice:
    'Congratulations! Your assigned level is complete. Revisit these activities anytime for more practice.',
  my_tutor_page: {
    avatarLabel: 'AI-generated',
    commonMistakeDescription: 'Puedes practicar tus mejoras o ver la conversación correspondiente',
    commonMistakes: 'Conocimientos lingüísticos',
    completedActivities: '{{numberOfCompletedActivities}} ¡Completado! ¡Bien hecho! 🏆',
    filterOptions: {
      enhancementArea: 'Tipo de error',
      enhancementAreaSearchPlaceholder: 'Buscar tipo de error',
      score: 'Puntuación',
      status: 'Tipo de actividad',
      statusSearchPlaceholder: 'Buscar tipo de actividad',
    },
    group: {
      filters: {
        all: 'Todos',
        currentDate: 'Especificar fecha',
        date: 'Fechas de conversaciones',
        last7days: 'Últimos 7 días',
        level: 'Nivel actual',
        rangeDate: 'Intervalo',
        topic: 'Temas',
      },
      table: {
        avgConversationTime: 'Tiempo promedio de conversación',
        conversation: 'Conversaciones',
        lastConversation: 'Última conversación',
        lastTopic: 'Último tema',
        level: 'Nivel actual',
        name: 'Nombre del estudiante',
        noResultsMessage: 'No se encontraron resultados para tu búsqueda o filtro.',
        title: 'Estudiantes',
        topics: 'Temas',
      },
    },
    jumpBackInSubtitle: 'You did great — now you can try again and get even better!',
    learn1: '{{totalLessonsCount}} cuestionario restante',
    learnN: '{{totalLessonsCount}} cuestionarios restantes',
    letsPractice: '¡Practiquemos!',
    myDashboard: 'Mi panel de control',
    noActivities:
      '"Let’s talk so I will be able to know your needs and suggest practice accordingly! 😊',
    practiceBtn: 'Práctica',
    practiceCount: 'You have {{count}} practice suggestion',
    practiceCountPlural: 'You have {{count}} practice suggestions',
    quizStatus: {
      COMPLETED: 'Completado',
      IMPROVEMENT: 'Mejora',
      PRACTICE: 'Práctica',
    },
    repeatTopic: 'Repeat Topic',
    report: {
      avgConversationDuration: 'Duración promedio',
      avgMistakes: 'Correcciones promedio',
      cefr: 'CEFR',
      conversation1: '{{numberOfConversations}} conversación',
      conversationLevel: 'Nivel',
      conversationSummary: 'Resumen de la conversación',
      conversationsN: '{{numberOfConversations}} conversaciones',
      description: 'Descripción',
      duration: 'Duración',
      errorsFound: 'Notado {{errors}} veces',
      evaluationSummary: 'Conversation Evaluation',
      topicOfConversation: 'Tema de conversación',
      totalConversations: 'Conversaciones totales',
      watchHistory: 'Revisar la conversación',
    },
    score: 'Puntuación',
    seeMyChatsBtn: 'Ver todos >',
    showMoreHistory: '+ Mostrar más',
    sortOptions: {
      createdDateAscending: 'Fecha, de la más remota a la más reciente',
      createdDateDescending: 'Fecha, de la más reciente a la más remota',
      rankAscending: 'Clasificación, de menor a mayor',
      rankDescending: 'Clasificación, de mayor a menor',
      scoreAscending: 'Puntuación, de baja a alta',
      scoreDescending: 'Puntuación, de más alta a más baja',
      statusAscending: 'Estado, De práctica a completado',
      statusDescending: 'Estado, De completado a práctica',
      topicAscending: 'Tema (A-Z)',
      topicDescending: 'Tema (Z-A)',
    },
    statistics: {
      averageConversationTime: '⏱️ Tiempo promedio de conversación',
      filter: {
        month: 'Los últimos 30 días',
        rangeDate: 'Selector de fecha personalizado',
        staticTitle: 'Mostrar datos de:',
        week: 'Esta semana',
      },
      studentsUsingTutor: '💬 Estudiantes que usan un instructor',
      totalStudents: '👤 Total de estudiantes',
    },
    youCanDoIt: '🚀 ¡Lo lograste!',
    youHas1Chat: 'Tienes 1 chat',
    youHasNChat: 'Tienes {{numberOfConversations}} chats',
    yourChats: 'Your Chats',
  },
  nameAndStatus: 'Nombre y estado',
  needHelp: '¿Necesitas ayuda?',
  new_password: 'Nueva contraseña',
  new_password_verification: 'Reingresar la nueva contraseña',
  next: 'Siguiente',
  nextPage: 'Página siguiente',
  nextQuestion: 'Siguiente pregunta',
  nextQuiz: 'Siguiente actividad',
  nextWord: 'Siguiente palabra',
  niceEffort: 'Buen esfuerzo,',
  noClassToImport: 'No hay clases para importar',
  noClassToImportDescription:
    'Primero deberás crear tus clases en tu página de Google Classroom (https://classroom.google.com/) y, después, podrás importar a tus estudiantes aquí.',
  noExtraCoins: 'Sin monedas extra',
  noLevelAssignedMessage: 'Please ask your teacher to set your level so you can start.',
  noLevelAssignedTitle: "You don't have a level assigned yet.",
  noLongerAvailable: 'Ya no está disponible; se ha eliminado de Google Classroom',
  noStudentMistake:
    'En caso de no tener estudiantes en esta clase, por favor, comunícate con la administración de tu escuela. ',
  noStudents: 'No hay estudiantes en esta clase',
  noTrailingSpaces: 'El nombre de usuario no puede tener espacios al final',
  none: 'Ninguno',
  notAvailable: 'No disponible',
  notFoundError: 'Error 404',
  notMadeIt: 'Parece que esta vez no lo has conseguido. Puedes',
  notifications: {
    event: {
      accountDeleted: {
        body: 'Tu cuenta de Hello ha sido borrada.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity your Hello account has been deleted.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity your Hello account has been deleted.',
        title: 'Tu cuenta ha sido borrada.',
      },
      adminDealExpired: {
        body: 'Your school’s Hello Britannica subscription has expired. Access through the website and our apps has been disabled for all users in your school. To renew your subscription and reinstate access, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
        title: 'Your school’s Hello Britannica subscription has expired',
      },
      assignedToNewClass: {
        actionText:
          'Please invite students to join your class or add them yourself through the Hello platform.',
        body: 'Te han asignado a {{className}}.',
        title: "You've been assigned to a class",
      },
      classDeleted: {
        body: 'La clase {{className}} fue borrada.',
        title: 'Your class has been deleted',
      },
      classGradeEdited: {
        body: 'El grado de la clase {{className}} fue cambiado de {{oldGradeStr}} a {{newGradeStr}}.',
        title: 'Your class grade has been updated',
      },
      classNameEdited: {
        body: 'El nombre de la clase {{oldClassName}} fue cambiado a {{newClassName}}.',
        title: 'Your class has been renamed',
      },
      classesDeleted: {
        body: 'Se han borrado {{numberOfClasses}} clases.',
        body_one: 'Se ha borrado 1 clase.',
        title: 'Your classes have been deleted',
      },
      coTeacherAdded: {
        body: '{{teacherFullName}} was assigned to your class {{className}}.',
        title: 'Co-Teacher was added to your class',
      },
      coTeacherAssignedToNewClass: {
        actionText:
          'Please invite students to join your class or add them yourself through the Hello platform.',
        body: 'You have been assigned to {{className}}.',
        title: "You've been assigned to a class",
      },
      coTeacherRemoved: {
        body: '{{teacherFullName}} was removed from your class {{className}}.',
        title: 'Co-Teacher was removed from your class',
      },
      dealDateExpirationUpdated: {
        body: 'Your school’s Hello Britannica subscription expiration date has been updated to {{dateStr}}.',
        title: 'Expiration date changed for your school’s Hello Britannica subscription',
      },
      interfaceLanguageChanged: {
        body: 'El idioma de la interfaz se fue cambiado a {{newLanguageStr}}.',
        title: 'Your interface language has been updated',
      },
      levelChanged: {
        body: 'Tu nivel de inglés ha cambiado de {{oldLevel}} a {{newLevel}}.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity your level has been changed from {{oldLevel}} to {{newLevel}}.<br/>You will now be redirected to the next level.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity your level has been changed from {{oldLevel}} to {{newLevel}}.<br/>You will now be redirected to the next level.',
        title: 'Tu nivel se ha actualizado.',
      },
      levelTestNotFinished: {
        body: 'Come back and finish a few more questions to begin practicing with Hello Britannica.',
        title: 'Say "Hello" to learning English',
      },
      levelTestNotTaken: {
        body: 'Check your English with a short quiz to unlock activities.',
        title: 'Get started with Hello Britannica',
      },
      licenseLimitReached: {
        actionText:
          'To extend your subscription with additional licenses, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
        body: 'Tu escuela alcanzó el límite de licencias. No se pueden registrar más estudiantes. Ponte en contacto con nosotros para añadir más licencias.',
        title: 'License limit reached',
      },
      movedToDifferentClass: {
        body: 'Te han trasladado de {{oldClassName}} a {{newClassName}}.',
        title: "You've been moved to a new class",
      },
      movedToDifferentClassWithLevelSet: {
        body: 'Your level was set to {{newLevel}}. Please log in again to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity you were assigned to a new class. Your level was set to {{newLevel}}. Please log in again to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity you were assigned to a new class. Your level was set to {{newLevel}}. Please log in again to get started.',
        title: 'You were assigned to a new class',
      },
      movedToDifferentClassWithPlacementTestRequired: {
        body: 'You are now required to take the level test. Please log in again and complete it to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity you were assigned to a new class. You are now required to take the level test. Please log in again and complete it to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity you were assigned to a new class. You are now required to take the level test. Please log in again and complete it to get started.',
        title: 'You were assigned to a new class',
      },
      nameChanged: {
        body: 'Tu nombre se ha actualizado a {{newFullName}}.',
        title: 'Your name has been updated',
      },
      removedFromClass: {
        body: 'Se te ha borrado de {{className}}.',
        title: "You've been removed from a class",
      },
      studentAdvancedToNewLevel: {
        body: '{{studentFullName}} de la clase {{className}} avanzó del nivel {{oldLevel}} al nivel {{newLevel}}.',
        title: 'A student reached a new level',
      },
      studentDealExpired: {
        body: 'Access to Hello Britannica has ended for your school. Please contact your teacher or school administrator for more information.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        title: 'Platform access has ended',
      },
      studentDeleted: {
        body: '{{studentFullName}} fue borrado de {{className}}.',
        title: 'A student has been deleted from your class',
      },
      studentGroupAllowIndividualAdvancement: {
        body: 'You will now advance to the next level.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. You will now advance to the next level.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. You will now advance to the next level.',
        title: 'A setting for your class has been changed.',
      },
      studentGroupLevelSet: {
        body: 'Your level was set to {{newLevel}}. Please log in again to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. Your level was set to {{newLevel}}. Please log in again to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. Your level was set to {{newLevel}}. Please log in again to get started.',
        title: 'A setting for your class has been changed.',
      },
      studentGroupPlacementTestRequired: {
        body: 'You are now required to take the level test. Please log in again and complete it to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. You are now required to take the level test. Please log in again and complete it to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. You are now required to take the level test. Please log in again and complete it to get started.',
        title: 'A setting for your class has been changed.',
      },
      studentInactivityDigest1m: {
        body: '{{numberOfStudents}} students have not engaged in Hello Britannica in the past month.',
        body_one: '1 student has not engaged in Hello Britannica in the past month.',
        title: 'Assign your students activities to complete in Hello Britannica',
      },
      studentInactivityDigest2w: {
        body: '{{numberOfStudents}} students have not engaged in Hello Britannica in the past two weeks.',
        body_one: '1 student has not engaged in Hello Britannica in the past two weeks.',
        title: 'Encourage your students to practice English with Hello Britannica',
      },
      studentWeeklyInactivity: {
        body: 'You scored {{lastCompletedActivityScore}} on your last Hello Britannica activity. Can you beat it?',
        body_noScore:
          "You haven't completed any Hello Britannica activity yet. Why won't you try it?",
        title: 'Don’t forget to practice your English today!',
      },
      studentsAssignedToClassByAdmin: {
        actionText:
          'Please ensure the new students complete the level test so they can start playing.',
        body: '{{numberOfStudents}} estudiantes fueron agregados a {{className}}.',
        body_one: '1 estudiante fue agregado a {{className}}.',
        title: 'Students have been added to your class',
      },
      studentsDeleted: {
        body: '{{numberOfStudents}} estudiantes fueron borrados de {{className}}.',
        body_one: '1 estudiante fue borrado de {{className}}.',
        title: 'Students have been deleted from your class',
      },
      studentsJoinedSinceLastLoginWithOutStudents: {
        body: 'No students have joined your school since your last login.',
        title: 'New students since your last login',
      },
      studentsJoinedSinceLastLoginWithStudents: {
        body: '{{numberOfStudents}} students have joined your school since your last login.',
        body_one: '1 student has joined your school since your last login.',
        title: 'New students since your last login',
      },
      studentsJoinedViaTeacherInvitation: {
        actionText:
          'Please ensure the new students complete the level test so they can start playing.',
        body: '{{numberOfStudents}} estudiantes se han unido a {{className}}.',
        body_one: '1 estudiante se ha unido a {{className}}.',
        title: 'A student has joined your class',
      },
      studentsLevelChangedByOperator: {
        body: '{{studentFullName}}’s English level has been changed from {{oldLevel}} to {{newLevel}}.',
        title: 'Your student’s level has been changed',
      },
      studentsMovedOutOfTheClass: {
        body: '{{numberOfStudents}} estudiantes fueron trasladados de la clase {{oldClassName}} a la clase {{newClassName}}.',
        body_one:
          '1 estudiante fue tasladado de la clase {{oldClassName}} a la clase {{newClassName}}.',
        title: 'Students moved out of the class',
      },
      teacherCreatedNewClass: {
        body: 'Se ha creado la clase {{className}}.',
        title: 'A new class has been created',
      },
      teacherDealExpired: {
        body: 'Access to Hello Britannica has ended for you and your students. Please contact your school administrator for more information.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        title: 'Hello Britannica access has ended',
      },
      teacherDeletedClassWithOutStudents: {
        body: 'La clase {{className}} fue borrada.',
        title: 'A class has been deleted',
      },
      teacherDeletedClassWithStudents: {
        body: 'La clase {{className}} fue borrada. {{numberOfStudents}} estudiantes también fueron borrados.',
        body_one: 'La clase {{className}} fue borrada. 1 estudiante también fue borrado.',
        title: 'A class has been deleted',
      },
      topicCompletedLowScore: {
        body: '{{studentFullName}} completed a topic with scores lower than 70 in skills: {{skillsListStr}}.',
        body_one:
          '{{studentFullName}} completed a topic with a score lower than 70 in {{skillsListStr}}.',
        title: 'Your student may need extra help',
      },
      weeklyClassSummaryWithActivity: {
        body: 'Here is your weekly summary of activity in Hello Britannica for {{className}} (week of {{dateStr}}): {{numberOfStudentsAdvancedToNewLevel}} students advanced to a new level / {{numberOfStudentsCompletedUnit}} students completed a unit / {{numberOfStudentsWereAdded}} students were added / {{numberOfStudentsWereDeleted}} students were deleted.',
        title: 'Weekly Report - Hello Britannica activity summary for {{className}}',
      },
      weeklyClassSummaryWithOutActivity: {
        body: "Here is your weekly summary of activity in Hello Britannica for {{className}} (week of {{dateStr}}): nothing has changed this week. Encourage your students to practice their English with Hello Britannica regularly and you'll see them completing units in no time!",
        title: 'Weekly Report - Hello Britannica activity summary for {{className}}',
      },
      weeklySchoolSummaryWithActivity: {
        body: 'Here is your weekly summary for {{schoolName}} (week of {{dateStr}}): {{numberOfStudentsWereAdded}} students were added / {{numberOfStudentsWereDeleted}} students were deleted / {{numberOfTeachersHaveJoined}} teachers have joined / {{numberOfClassesWereCreated}} classes were created / {{numberOfStudentsAdvancedToNewLevel}} students advanced to a new level.',
        title: 'Weekly Report - Hello Britannica activity summary for {{schoolName}}',
      },
      weeklySchoolSummaryWithOutActivity: {
        body: 'Here is your weekly summary for {{schoolName}} (week of {{dateStr}}): nothing has changed this week. To get the most out of Hello Britannica, remind teachers to encourage their students to practice their English language skills regularly.',
        title: 'Weekly Report - Hello Britannica activity summary for {{schoolName}}',
      },
    },
    list: {
      allNotificationsMessage: 'No hay más notificaciones de los últimos 30 días.',
      markAllAsReadButton: 'Marcar todos como leídos',
      noNotificationsMessage: 'No hay notificaciones nuevas.',
      sendDataWithOperator: '{{createdAtStr}} | por {{operatorFirstName}} {{operatorLastName}}',
      sendDataWithoutOperator: '{{createdAtStr}}',
      title: 'Notificaciones',
    },
    popup: {
      okButton: 'OK',
    },
  },
  ofThisSite: 'de este sitio.',
  offlineNotification: {
    button: 'OK',
    description: 'When you will be online again, you will be able to continue using the platform.',
    title: 'You are currently offline.',
  },
  ok: 'OK',
  okLetsGo: 'OK, ¡vamos!',
  oneMoreMistake: 'Un error más acabará el juego,',
  onlyNumbersAllowed: 'Solo se permiten números',
  oops: 'Ups',
  oopsDots: '¡Uy!',
  orClickHereToSendAgain: 'O <0>haz clic aquí</0> para volver a enviar el código.',
  orLoginWithGoogle: 'O continúa con Google Classroom',
  organizationNameTooLong: 'School name can be up to 70 characters.',
  outOf: 'de',
  overallProgress: 'Progreso general',
  pageNotFound: 'No se encontró la página',
  partialImportError:
    'Algunas clases no pudieron importarse porque ya fueron importadas por otro maestro. El resto de las clases fueron importadas con éxito.',
  passRate: 'Tasa de aprobación',
  password: 'Contraseña',
  passwordMinimumLength: 'Longitud mínima de 8 caracteres.',
  password_changed_successfully: 'La contraseña se ha cambiado correctamente',
  passwordsDontMatch: 'Las contraseñas no coinciden',
  pause_game: 'Pausar el juego',
  paussed: 'en pausa',
  phone: 'Teléfono',
  pictureOfTheDay: 'Imagen del día',
  play_sound: 'Reproducir sonido',
  pleaseChooseYourOwnPassword: 'Por favor, elige tu propia contraseña',
  pleaseEnterTheFollowing: 'Por favor, complete la siguiente información para comenzar su',
  pleaseEnterYourDetails: 'Por favor, ingresa tus datos',
  pleaseSelectYourAccount: 'Por favor, selecciona tu cuenta o inicia sesión desde otra',
  pleaseTakeAMoment: 'Por favor, tómese un momento para registrar su escuela.',
  pleaseTryAgain: 'Por favor, inténtalo de nuevo.',
  practice: 'Practica',
  practiceAgain: 'Practica otra vez',
  practiceProperPronunciation:
    'Practica decir palabras o frases nuevas. Haz clic en el micrófono azul y dilas en voz alta. Vuelve a hacer clic en el micrófono cuando termines de hablar. Habla lentamente.',
  practiceYourVocabulary: 'Practica tu vocabulario',
  preferences: 'Preferencias',
  premiumSection: {
    description:
      'Aquí puede ver información importante o recursos del administrador de su escuela o de Britannica.',
    title: 'Un mensaje para los profesores',
    unlock: 'Leer más',
  },
  preparationAudioToImage:
    'Esta es una divertida actividad para escuchar. Haz clic en el botón de oír y escucha el audio. Luego, conéctalo con la imagen correcta.',
  preparationAudioToImageMobile:
    'Esta es una divertida actividad para escuchar. Haz clic en el botón de oír y escucha el audio. Luego, conéctalo con la imagen correcta.',
  preparationClosedSpelling:
    'Esta es una forma divertida de practicar la ortografía. Observa la imagen. Usa las letras para formar las palabras.',
  preparationClosedSpellingMobile:
    'Esta es una forma divertida de practicar la ortografía. Observa la imagen. Usa las letras para formar las palabras.',
  preparationDescriptionFirstPart:
    'Esta es una divertida actividad para escuchar. Haz clic en el botón de oír y escucha el audio. Luego, conéctalo con la imagen correcta.',
  preparationDescriptionFirstPartMobile:
    'Esta es una divertida actividad para escuchar. Haz clic en el botón de oír y escucha el audio. Luego, conéctalo con la imagen correcta.',
  preparationDescriptionSecondtPart: '¡Es como un rompecabezas que te ayuda a aprender inglés!',
  preparationGrammar:
    'Lee las preguntas y elige la opción correcta. ¡Busca el dato gramatical! ¿Estás listo? ¡A practicar la gramática! ',
  preparationGrammarMobile:
    'Lee las preguntas y elige la opción correcta. ¡Busca el dato gramatical! ¿Estás listo? ¡A practicar la gramática! ',
  preparationImageToText:
    '¡Aprende inglés y diviértete! Mira la imagen y conéctala con la opción correcta.',
  preparationImageToTextMobile:
    '¡Aprende inglés y diviértete! Mira la imagen y conéctala con la opción correcta.',
  preparationListen:
    '¡Diviértete escuchando! Haz clic en el botón de oír y escucha. Luego, elige la respuesta correcta.',
  preparationListenMobile:
    '¡Diviértete escuchando! Haz clic en el botón de oír y escucha. Luego, elige la respuesta correcta.',
  preparationMemory: '¡Diviértete y practica inglés! Conecta las palabras con las imágenes.',
  preparationMemoryMobile: '¡Diviértete y practica inglés! Conecta las palabras con las imágenes.',
  preparationNaturalConversation:
    '¡Practica hablar en inglés! Haz clic en el botón de oír y escucha. Elige la respuesta correcta. Luego, haz clic en el micrófono azul y dila en voz alta. Vuelve a hacer clic en el micrófono cuando termines de hablar.',
  preparationNaturalConversationMobile:
    '¡Practica hablar en inglés! Haz clic en el botón de oír y escucha. Elige la respuesta correcta. Luego, haz clic en el micrófono azul y dila en voz alta. Vuelve a hacer clic en el micrófono cuando termines de hablar.',
  preparationOpenWriting:
    '¡Practica la escritura de forma divertida! Lee la pregunta y observa la imagen. Luego, escribe la respuesta.',
  preparationOpenWritingMobile:
    '¡Practica la escritura de forma divertida! Lee la pregunta y observa la imagen. Luego, escribe la respuesta.',
  preparationRead: 'Lee y responde las preguntas. ¡Vamos!',
  preparationReadMobile: 'Lee y responde las preguntas. ¡Vamos!',
  preparationSecondtPartGrammar: 'No te preocupes, recibirás pistas que te ayudarán en el camino.',
  preparationSecondtPartImageToText: '¡Buena suerte!',
  preparationSecondtPartSpeak: '¡Buena suerte!',
  preparationSecondtPartTextToImage: '¡Buena suerte!',
  preparationSecondtPartVocabulary:
    'Veamos qué tan bien dominas tu vocabulario. <b>¡Buena suerte!</b>',
  preparationSpeaking:
    'Practica decir palabras o frases nuevas. Haz clic en el micrófono azul y dilas en voz alta. Vuelve a hacer clic en el micrófono cuando termines de hablar. Habla lentamente.',
  preparationSpeakingMobile:
    'Practica decir palabras o frases nuevas. Haz clic en el micrófono azul y dilas en voz alta. Vuelve a hacer clic en el micrófono cuando termines de hablar. Habla lentamente.',
  preparationTextToImage:
    '¡Esta es una forma divertida de practicar inglés! Lee y elige la imagen correcta.',
  preparationTextToImageMobile:
    '¡Esta es una forma divertida de practicar inglés! Lee y elige la imagen correcta.',
  preparationTextToText:
    '¡Diviértete con nuevas palabras, gramática y lectura! Lee las oraciones o las preguntas y elige la respuesta correcta. ',
  preparationTextToTextMobile:
    'Mejora tu comprensión lectora, tu vocabulario y tu gramática eligiendo la respuesta correcta que mejor complete las siguientes oraciones.',
  preparationVocabulary:
    '¡Practica palabras nuevas! Sigue las instrucciones y elige la opción correcta.',
  preparationVocabularyMobile:
    '¡Practica palabras nuevas! Sigue las instrucciones y elige la opción correcta.',
  privateTutor: 'Instructor privado',
  processing: 'Procesando',
  profile: 'Perfil',
  progress: 'Progreso',
  provideClassCode: 'Por favor, indica el código de tu clase',
  question: 'Pregunta',
  questions: 'Preguntas',
  questionsAndConcerns: 'tus preguntas y comentarios.',
  questionsLeft: 'quedan más preguntas',
  quiz: 'Actividad',
  quizzes: 'Juegos',
  quizzesCompleted: 'Juegos completados',
  ran_out_of_time: 'Parece que se te acabó el tiempo otra vez. Esta pregunta se marcará como',
  rateYourself: 'Calificate a ti mismo',
  readMore: 'Leer más',
  readWithImageStartQuizInstructions: 'Lee el texto y responde las preguntas que siguen.',
  read_tip: 'Consejo de leer',
  readyToChooseYourAvatar: '¿Listo/a para elegir tu avatar?',
  refresh: 'Actualizar',
  registrationDealExpiredMessageDescription:
    'Comunícate con tu maestro o con el administrador de tu escuela para que te oriente.',
  registrationDealExpiredMessageDescriptionAdmin:
    'Access through the website and our apps has been disabled for all users in your school. To renew your subscription and reinstate access, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
  registrationDealExpiredMessageDescriptionTeacher:
    'Please contact your school administrator for guidance.',
  registrationDealExpiredMessageTitle: 'El enlace ya caducó 😕',
  registrationDealLimitReachedMessageDescription:
    'Comunícate con tu maestro o con el administrador de tu escuela para que te oriente.',
  registrationDealLimitReachedMessageTitle: 'Se alcanzó el límite de usuarios para esta escuela 😕',
  reports: {
    activitiesCompletedInLevel: 'Actividades completadas en el nivel {0}',
    allLevelsAvgTime: '📊 Promedio de tiempo en todos los niveles',
    attemptsAndHints: 'Intentos y pistas',
    averagePerSkill: 'Promedio por habilidad',
    avgActivitiesCompleted: 'Promedio de actividades completadas',
    avgAttempts: 'Intentos',
    avgAttemptsPerActivity: 'Intentos',
    avgFailureRate: 'Tasa promedio de reprobación',
    avgHintsPerActivity: 'Promedio de pistas por actividad',
    avgPassRate: 'Tasa promedio de aprobación',
    avgPerWeek: 'Promedio por semana',
    avgSkillScores: 'Puntajes por habilidad',
    avgStreakLength: 'Duración de la racha',
    avgStreakPerWeek: 'Promedio de racha por semana',
    avgStudentProgress: 'Progreso de los estudiantes en el nivel actual',
    avgTimeSpent: 'Tiempo dedicado',
    continuousEngagement: 'Promedio de días/semanas de compromiso continuo',
    daysPerWeek: '{0} días por semana',
    engagedStudentsWord_one: 'engaged student',
    engagedStudentsWord_other: 'engaged students',
    engagement: 'Compromiso',
    failureRate: 'Tasa de reprobación',
    inCurrentLevel: 'En el nivel actual',
    longestStreak: 'Racha más larga',
    onActivities: 'Promedio de actividades por nivel',
    overallProgressInLevel: 'Progreso general en el nivel {0}',
    passRate: 'Tasa de aprobación',
    perActivity: 'Promedio por actividad',
    perLevel: 'Promedio por nivel',
    previous7Days: 'Los 7 días anteriores.',
    progress: 'Progreso',
    remark:
      'Estos datos representan a <b>{0}</b> estudiantes comprometidos de un total de <b>{1}</b> estudiantes de la clase.',
    skippedActivitiesComment: '* Las actividades omitidas se incluyen en el total de actividades',
    streakLast7Days: 'Racha de los últimos 7 días',
    streakLength: 'Duración de la racha',
    studentsOnlyWord_one: 'student',
    studentsOnlyWord_other: 'students',
    timeSpentOnActivites: 'Tiempo dedicado a las actividades',
    total: 'Total',
    totalHintsUsed: 'Total de pistas utilizadas',
    totalInPrev7Days: 'Total en los 7 días anteriores',
    totalStudents: 'Total de estudiantes',
  },
  requirements: 'Requisitos',
  resendVerificationCode: '¿No lo ha recibido? Volver a enviar el código',
  resetPassword: 'Reestablecer la contraseña',
  resetPasswordRequest: 'El pedido para reestablecer la contraseña fue enviado a tu maestro.',
  resolved: 'Ok, ¡vamos!',
  results: 'Resultados',
  resume: 'Reanudar',
  review: 'Revisar',
  reward: 'Recompensa',
  saturdayShort: 'sáb',
  save: 'Guardar',
  schoolName: 'Nombre de la escuela',
  score: 'Puntuación',
  scrollToTop: 'Desplazarse hacia el comienzo',
  searchClasses: 'Busca y/o selecciona una opción.',
  searchForStudent: 'Buscar por estudiante',
  searchStatus: 'Buscar estado',
  selectAll: 'Seleccionar todo',
  selfPracticeStreak: 'Racha de la autopráctica',
  send: 'Enviar',
  sendNow: 'Enviar ahora',
  settings: {
    about_me: 'Sobre mí',
    add_students: {
      add_student: 'Añadir nuevo estudiante',
      add_students_manually: 'Añadir a mano',
      button_next: 'Siguiente',
      classCreatedDescriptionNoLevelTest:
        'Your students have been emailed instructions for resetting their password. Once your students log in, they will be placed at the default level and may begin their learning journey.',
      click_to_browse: 'haz clic para navegar',
      create_students: 'Los siguientes estudiantes recibirán una invitación por correo electrónico',
      download: 'Descargar',
      download_sample: 'un archivo Excel (xlsx) de modelo.',
      drag_here: 'Arrastra un archivo aquí o ',
      email_will_be_send:
        'Se enviará al estudiante un correo electrónico con una contraseña temporaria',
      enroll_students: 'Inscribir estudiantes',
      enrollment_unsuccessful: '⚠️ ¡No pudo completarse la inscripción!',
      enrollment_unsuccessful_description:
        'Los siguientes estudiantes no pudieron ser inscritos porque su dirección de correo electrónico ya está en uso.',
      errors: {
        bad_formatting:
          'El archivo no tiene el formato correcto. <br/> Por favor, revise los datos y haga las correcciones necesarias.',
        email_in_use: 'Esta dirección de correo electrónico ya está registrada',
        email_incorrect: 'Por favor, ingresa una dirección de correo electrónico válida.',
        file_empty: 'El archivo que estás intentando subir está vacío',
        file_too_large: 'El archivo es demasiado grande. El tamaño máximo permitido es de 256KB.',
        first_name_incorrect: 'El nombre contiene caracteres no válidos o es demasiado largo.',
        first_name_missing: 'El nombre es obligatorio.',
        first_name_too_long: 'Nombre: máximo 30 caracteres.',
        last_name_incorrect: 'El apellido contiene caracteres no válidos o es demasiado largo.',
        last_name_missing: 'El apellido es obligatorio.',
        last_name_too_long: 'Apellido: máximo 40 caracteres.',
        limit_reached:
          'El número máximo de estudiantes por clase es de 50. <br/>Elimine y cargue un archivo nuevo.',
        limit_reached_description: 'Su clase contiene el número máximo de estudiantes permitido.',
        limit_reached_title: 'Esta clase ya está llena.',
        max_number_of_students:
          'El número máximo de estudiantes por clase es de 50. <br/> Por favor, elimine el archivo y cargue uno nuevo.',
        students_not_registered: 'Algunos estudiantes no se registraron.',
        username_invalid: 'Este nombre de usuario ya está en uso',
        username_missing: 'Es necesario un nombre de usuario.',
        wrong_format:
          'El formato del archivo es incorrecto. <br/> Asegúrese de subir un archivo Excel (xlsx).',
      },
      invite_students: 'Invitar estudiantes',
      not_enough_licenses_blocked_one:
        'Tu solicitud para añadir a 1 estudiante ha sido bloqueada porque el límite de la licencia de tu escuela no permite incluirlo.',
      not_enough_licenses_blocked_other:
        'Tu solicitud de añadir {{requested}} estudiantes ha sido bloqueada porque el límite de la licencia de tu escuela no permite incluirlos a todos.',
      not_enough_licenses_remaining_one:
        'Solo queda 1 lugar disponible. Puedes invitar a menos estudiantes para ocupar el lugar disponible o ponerte en contacto con nosotros para obtener ayuda.',
      not_enough_licenses_remaining_other:
        'Solo quedan {{available}} lugares disponibles. Puedes invitar a menos estudiantes para ocupar los lugares disponibles o ponerte en contacto con nosotros para obtener ayuda.',
      not_enough_licenses_teacher_blocked_one:
        'Tu solicitud para añadir a 1 estudiante ha sido bloqueada porque el límite de la licencia de tu escuela no permite incluirlo.',
      not_enough_licenses_teacher_blocked_other:
        'Tu solicitud para añadir {{requested}} estudiantes ha sido bloqueada porque el límite de la licencia de tu escuela no permite incluirlos a todos.',
      not_enough_licenses_teacher_remaining_one:
        'Solo queda 1 lugar disponible. Puedes invitar a menos estudiantes para ocupar el lugar disponible o ponerte en contacto con el administrador de tu escuela para que te oriente.',
      not_enough_licenses_teacher_remaining_other:
        'Solo quedan {{available}} lugares disponibles. Puedes invitar a menos estudiantes para ocupar los lugares disponibles o ponerte en contacto con el administrador de tu escuela para que te oriente.',
      partial_success: '⚠️ Éxito parcial',
      partial_success_description:
        '{{addedStudents}} de {{totalStudents}} estudiantes han sido inscritos con éxito en esta clase.<br/>Se les ha enviado un correo electrónico con una contraseña temporal.',
      upload_attention_text:
        '⚠️ Tu clase tiene {{curent}}/{{limit}} estudiantes.<br/>Puedes inscribir {{certified}} estudiantes más.',
      upload_attention_text_new_class: '⚠️ Max. {{limit}} estudiantes por clase',
      upload_file: 'Sube el archivo Excel de tus estudiantes',
      upload_successful: 'Tu archivo fue cargado exitosamente.',
    },
    class: 'Mi clase',
    current_level: 'Nivel actual',
    delete_class: {
      areYouSure: '¿Estás seguro?',
      cancel: 'Cancelar',
      classNotEmpty: 'No puedes borrar una clase que contiene estudiantes.',
      classNotEmptyDescription:
        'Si quieres borrar esta clase, primero debes borrar a los estudiantes. Puedes hacer esto abriendo el perfil de cada estudiante y haciendo clic en el ícono de Editar.',
      delete: 'Borrar',
      deletingFailed: 'Tuvimos un problema técnico.',
      deletingFailedDescription:
        'Nuestros servidores no están respondiendo. Por favor inténtalo de nuevo. Si el problema persiste, comunícate con nosotros a través de <a href="mailto:{{email}}">{{email}}</a>',
      description: 'Estás a punto de borrar tu clase. Está acción no se puede volver atrás.',
      tryAgain: 'Volver a intentar',
    },
    delete_student: {
      areYouSure: '¿Estás seguro?',
      cancel: 'Cancelar',
      choose: 'Seleccionar',
      delete: 'Borrar',
      deleteStudent: 'Borrar estudiante.',
      deletingFailed: 'No se pudo borrar.',
      deletingFailedDescription: '',
      description:
        'Al borrar a este estudiante, se lo eliminará de la plataforma. Este estudiante ya no podrá iniciar sesión y se perderán todos sus datos de progreso. Por favor, indica un motivo:',
      reason: 'Razón',
      reasons: {
        aClericalError: 'Un error administrativo',
        other: 'Otro',
        requestedToBeRemoved: 'El estudiante o sus padres pidieron que se lo borrara.',
      },
      why: '¿Por qué?',
    },
    grade: 'Grado',
    home: 'Inicio',
    interface_language: 'Idioma de la interfaz',
    language: 'Idioma',
    logout: 'Cerrar sesión',
    my_classes: 'Mis clases',
    my_games: 'Mis juegos',
    my_students: 'Mis estudiantes',
    my_tutor: 'Mi tutor privado',
    native_language: 'Mi idioma nativo',
    privacy_policy: 'Política de privacidad',
    profile: 'Perfil',
    school_id: 'Mi escuela',
    security: 'Seguridad',
    title: 'Configuración',
    username: 'Mi nombre',
  },
  setupYourClass:
    'Configura tu clase y recibirás un código de clase para enviar a tus estudiantes. ¡Ellos harán un rápido proceso de registro y podrán unirse a tu clase.',
  signIn: 'Iniciar sesión',
  signYouIn: 'Iniciando sesión…',
  sign_out: 'Cerrar sesión',
  sixDigits: '6 dígitos',
  sixDigitsAtLeast: 'El código debe tener al menos 6 dígitos',
  skills: {
    grammar: 'Gramática',
    listen: 'Comprensión auditiva',
    read: 'Lectura',
    speak: 'Expresión oral',
    spelling: 'Ortografía',
    vocabulary: 'Vocabulario',
  },
  skip: 'Saltar',
  skipAllRecording: 'Saltar todas las grabaciones',
  skipThisQuestion: 'saltar esta pregunta',
  skipped: 'Omitida',
  skippedPopUpSummary: {
    speak: {
      bannerTitle: 'Omitida',
      description: 'Esta actividad se omite y no se calificará. Puedes volver a ella más tarde.',
      title: 'Has elegido saltarte esta actividad',
    },
  },
  somewhatAgree: 'Estoy parcialmente de acuerdo',
  sortBy: 'Ordenar por:',
  soundAnalyzingSentences: {
    '0': 'Por favor, espera mientras analizamos tu respuesta',
    '1': 'Las actividades de conversación pueden ayudarte a aprender mejor el inglés.',
    '2': 'Ya casi está...',
    numberOfSentences: '3',
  },
  speak_tip: 'Consejo de hablar',
  spelling_tip: 'Consejo de ortografía',
  stars: 'Estrellas',
  start: 'Comenzar',
  startActivity: 'Iniciar actividad',
  startLevelTest: 'Prueba de nivel de inicio',
  startNewConversation: 'Iniciar una nueva conversación',
  startQuiz: 'Iniciar el juego',
  startSkippedActivities: 'Comenzar las actividades omitidas',
  startingLevel: 'Nivel de inicio',
  startingReward: 'Recompensa inicial',
  state: 'Estado',
  status: 'Estado',
  studentInstructions: 'Instrucciones para los estudiantes',
  studentMetricsDashboard: {
    charts: {
      avgScores: {
        subTitle: 'Puntaje promedio de los estudiantes por habilidad',
        title: 'Puntajes de los estudiantes',
      },
      avgStudentGrowth: {
        subTitle: 'Progreso promedio acumulado por mes a través de los niveles',
        title: 'Progreso total en el nivel',
        tooltipTitle: 'Progreso total en el nivel',
      },
      avgStudentProgressAtCurrentLevel: {
        levelInfo: 'Nivel {{level}}\n({{studentCount}} estudiantes)',
        subTitle: 'Progreso promedio de los estudiantes en cada nivel',
        title: 'Progreso de los estudiantes en el nivel actual',
      },
      kpis: {
        averageTimeSpent: {
          label: '📊 Tiempo promedio dedicado',
          tooltip: 'Promedio de todo el tiempo dedicado por los estudiantes a jugar activamente.',
        },
        failureRate: {
          label: '🙁 Tasa de reprobación',
          tooltip:
            'El porcentaje de actividades intentadas que se reprobaron, se omitieron o no se completaron.',
        },
        passRate: {
          label: '✅ Tasa de aprobación',
          tooltip: 'El porcentaje de actividades intentadas que se aprobaron con éxito.',
        },
        studentsThatPassedLevel: {
          label: '🚀 Estudiantes que aprobaron un nivel',
          tooltip: 'Número de estudiantes que aprobaron al menos un nivel.',
        },
        totalActivitiesPassed: {
          label: '🏆 Total de actividades aprobadas',
          tooltip: 'El número de actividades únicas que se aprobaron con un puntaje de 60 o más.',
        },
        totalTimeSpent: {
          label: 'Tiempo total dedicado',
          tooltip: 'Suma de todo el tiempo dedicado por los estudiantes a jugar activamente.',
        },
      },
      studentLevelProgression: {
        levelInfo: 'Nivel {{level}}\n({{studentCount}} estudiantes)',
        subTitle: 'Número de estudiantes en cada nivel, ordenados por nivel de inicio',
        title: 'Progresión del nivel de los estudiantes',
        tools: {
          studentStartedAtL1: 'Comenzó en N1',
          studentStartedAtL2: 'Comenzó en N2',
          studentStartedAtL3: 'Comenzó en N3',
          studentStartedAtL4: 'Comenzó en N4',
          studentStartedAtL5: 'Comenzó en N5',
          studentStartedAtL6: 'Started at L6',
        },
      },
      studentsAcrossSkills: {
        subTitle: 'Porcentaje de alumnos que aprobaron por habilidad',
        title: 'Éxito de los estudiantes',
        tools: {
          failure: 'Reprobación (Menos del 60)',
          pass: 'Aprobado',
        },
      },
    },
    drillDown: {
      skills: {
        columns: {
          class: 'Clase',
          classNameAndGrade: 'Clase y grado',
          currentLevel: 'Nivel actual',
          grade: 'Grado',
          name: 'Nombre completo del estudiante',
          nameAndTeacher: 'Nombre y maestro',
          skillGrammar: 'Gramática',
          skillListening: 'Comprensión auditiva',
          skillPronunciation: 'Promedio de pronunciación',
          skillReading: 'Lectura',
          skillSpeaking: 'Expresión oral',
          skillSpelling: 'Ortografía',
          skillVocabulary: 'Vocabulario',
          teacherNames: 'Nombre(s) del maestro',
        },
        loadingData: 'Cargando datos de habilidades...',
        title: {
          AvgScores: 'Puntajes de los estudiantes',
          StudentsAcrossSkills: 'Éxito de los estudiantes',
        },
        totalStudents: 'Estudiantes comprometidos: {{totalStudents}}',
      },
      students: {
        allLevelsHint: 'Los datos reflejan el desempeño de los estudiantes en todos los niveles.',
        columns: {
          class: 'Clase',
          completedActivities: 'Actividades completadas',
          currentLevel: 'Nivel actual',
          firstLogin: 'Primer inicio de sesión',
          grade: 'Grado',
          lastLogin: 'Último inicio de sesión',
          name: 'Nombre completo del estudiante',
          nameAndTeacher: 'Nombre y maestro',
          progress: 'Progreso',
          score: 'Puntuación',
          startingLevel: 'Nivel de inicio',
          teacherNames: 'Nombre(s) del maestro',
          timeSpent: 'Tiempo dedicado',
          totalActivities: 'Total de actividades',
        },
        levelHint: 'Los datos reflejan el desempeño de los estudiantes en todos los niveles.',
        loadingData: 'Cargando datos del nivel...',
        notAvailable: 'No disponible',
        subTitle: '*El nivel de inicio fue modificado.',
        title: {
          AvgStudentGrowth: 'Progreso total en el nivel',
          AvgStudentProgressAtCurrentLevel: 'Progreso de los estudiantes en el nivel actual',
          StudentLevelProgression: 'Progresión del nivel de los estudiantes',
        },
        totalStudents: 'Estudiantes comprometidos: {{totalStudents}}',
      },
    },
    emptyState: {
      filter: {
        description:
          'Los estudiantes no comenzaron actividades durante el período de tiempo seleccionado.',
        title: 'No hay datos para el período seleccionado',
      },
      global: {
        description:
          'Cuando los estudiantes comiencen sus actividades, su progreso aparecerá aquí.',
        title: 'Aún no hay actividad.',
      },
    },
    exportData: {
      button: 'Exportar datos',
      fileName: 'Panel de métricas de estudiantes',
      sheet: {
        levels: 'Niveles',
        skills: 'Habilidades',
      },
    },
    filters: {
      completedActivities: 'Actividades completadas',
      currentLevel: 'Nivel actual',
      currentLevelSearchPlaceholder: 'Buscar nivel',
      firstLogin: 'Primer inicio de sesión',
      grade: 'Grado',
      gradeSearchPlaceholder: 'Buscar grado',
      group: 'Nombre de la clase',
      groupSearchPlaceholder: 'Buscar clase',
      lastLogin: 'Último inicio de sesión',
      startingLevel: 'Nivel de inicio',
      startingLevelSearchPlaceholder: 'Buscar nivel',
      studentName: 'Nombre del estudiante',
      studentNameSearchPlaceholder: 'Buscar estudiante',
      teacher: 'Nombre del maestro',
      teacherSearchPlaceholder: 'Buscar maestro',
      timeRange: 'Intervalo de tiempo',
      timeSpent: 'Tiempo dedicado',
    },
    loadingMetrics: 'Cargando métricas...',
    pageTabs: {
      data: 'Datos',
      metrics: 'Métricas',
    },
    totalStudents: 'Estudiantes comprometidos: {{totalStudents}}',
  },
  studentName: 'Nombre del estudiante',
  studentProfile: 'Perfil del estudiante',
  studentReport: 'Informe del estudiante',
  students: 'Estudiantes',
  studentsContent: {
    levelHint: 'Los datos reflejan el desempeño de los estudiantes en el nivel actual.',
  },
  subject: 'Asunto',
  submit: 'Enviar',
  suggested_languages: 'Idiomas sugeridos',
  sundayShort: 'dom',
  sync: 'Sincronizar',
  syncDataDescription:
    'Esta acción sincronizará la diferencia de datos entre Hello y Google Classroom, e incluirá las actualizaciones más recientes.',
  syncYourData: 'Sincroniza tus datos',
  synonyms: 'Sinónimos',
  tapToSpeak: 'Pulsa para hablar',
  teacherInstructions: 'Instrucciones para los docentes',
  teacherLetsBeginn: '¡Comencemos!',
  teacherMobile: {
    classesMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
    studentsMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
    tutorMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
  },
  teacherName: 'Nombre del profesor/a',
  teachers: 'Profesores',
  teachersThatHaveRegistered: 'Profesores que se han registrado',
  temporaryPassword: 'La contraseña transitoria:',
  termsAndConditions: 'Términos y condiciones',
  testYourEnglish: 'Pon a prueba tu nivel de inglés',
  thankYou: '¡Gracias!',
  thanksForSubmission: '¡Gracias por tu envío!',
  thats_the_way: '¡Así se hace!',
  theAnswerIsIncorrectWhatWeHeardWas: 'La respuesta es incorrecta. Lo que escuchamos fue:',
  thisStudentIsInactive:
    'El estudiante está inactivo. Ha sido invitado a la clase, pero aún no ha cambiado su contraseña temporaria y no ha comenzado la prueba de nivelación inicial.',
  thisStudentIsLevelTestIncomplete:
    'Este estudiante aún no ha completado su prueba de nivelación inicial. Una vez que lo haya hecho, podrás ver su progreso.',
  thisTopicWillHelpMe: 'Este tema me ayudará',
  thursdayShort: 'jue',
  timeIsUp: '¡Se acabó el tiempo!',
  timeSpent: 'Tiempo dedicado',
  tip: '¡Consejo!',
  tipsAndTricks: 'Consejos y trucos',
  to: 'Para',
  toImproveYourVocabulary: 'Para mejorar tu vocabulario,',
  toNextQuestion: 'a la siguiente pregunta',
  toggle: 'Alternar',
  topicProgress: 'Progreso del tema',
  topics: 'Temas',
  totalActivities: 'Total de actividades',
  totalCoins: 'Total de monedas',
  totalHintsUsed: 'Total de pistas utilizadas',
  totalProgressWithinLevel: 'Progreso total dentro del nivel',
  totalQuizzes: 'Total de juegos',
  totalTimeSpent: 'Tiempo total dedicado',
  totalTimeSpentTooltip: 'Suma de todo el tiempo dedicado por los estudiantes a jugar activamente.',
  totalTimeSpent_mobile: 'Tiempo total dedicado',
  tries: 'intentos',
  tryAgain: 'Intenta de nuevo',
  tryAgainBtn: 'Intenta una vez más',
  tryAgainLater: 'Vuelva a intentarlo más tarde.',
  tryAgainOneMore: 'intentarlo una vez más o pasar',
  tryAgainOrKeepGoing: 'Inténtalo de nuevo o continúa',
  tryBetter: '¡La práctica hace al maestro!',
  tryToGetAllStars: 'Esta vez, ¡intenta conseguir todas las estrellas!',
  tuesdayShort: 'mar',
  tutorBack: '< Volver',
  tutorCorrectAnswerIsShort: 'La respuesta correcta es <strong>{{answer}}</strong>',
  tutorEndActivityBtn: 'End Activity',
  tutorEndConversationBtn: 'Terminar la conversación.',
  tutorNewConversation:
    '👋🏻 Hey {{name}}!\nYou\'re building <br class="desktop-br">stronger <span style="color: #05abf4" >grammar</span>\nand <span style="color: #ff9f4c">expression</span> skills!',
  tutorRouterPrompt: {
    activity: {
      cancelBtn: 'Continuar',
      confirmBtn: 'Terminar la conversación',
      description: 'Si lo terminas ahora, esta conversación no se guardará.',
      title: '¿Quieres terminar tu conversación?',
    },
    cancelBtn: 'Let’s Keep Talking',
    confirmBtn: 'End Conversation',
    description: 'If you end it now, this conversation will not be saved.',
    fromCanDoBeforeStarted: {
      cancelBtn: 'Continue with Tutor',
      confirmBtn: 'I’m sure',
      title: 'Are you sure you don’t want to review {{topicName}}?',
    },
    title: 'End the conversation?',
  },
  uncorrectPronounce: 'Inténtalo de nuevo o pasa a la siguiente pregunta.',
  understandingYourEnglishLevel: 'Estamos empezando a entender tu nivel de inglés.',
  unfortunately: 'Lamentablemente, no pasaste, por lo que no recibirás monedas por este juego.',
  university: 'Universidad',
  update: 'Actualización',
  uploadCsvErrorModalDescription:
    'Es posible que tenga algunos problemas relacionados con Internet.<br /> Por favor, inténtalo de nuevo.',
  uploadCsvErrorModalTitle: 'Error de carga',
  useTheCoins: 'Usa las monedas que has ganado para obtener pistas.',
  userDataSuccessfullyUpdated:
    'Los detalles se actualizaron correctamente. Por favor, pídele al estudiante que cierre la sesión y vuelva a iniciarla para ver los cambios.',
  userStreak: {
    subTitle: 'Practica cada día para convertirte en un MAESTRO',
    title: '¡Sigue adelante!',
  },
  username: 'Nombre de usuario',
  usernameAlreadyExists: 'Este nombre de usuario ya está en uso',
  usernameTooLong: 'El nombre de usuario es demasiado largo',
  usingYourMicrophone:
    'Utilizando el micrófono, habla despacio y con claridad y asegúrate de que no haya ruido de fondo.',
  validation: {
    code_required: 'Se requiere código',
    confirm_password_required: 'Es necesario confirmar la contraseña.',
    email_required: 'Correo electrónico obligatorio',
    password_required: 'Se requiere una contraseña',
    username_or_email_required: 'Es necesario un nombre de usuario o un correo electrónico',
  },
  validationCodeInvalid: 'El código de validación no es válido',
  verificationCode: 'Código de verificación',
  verificationCodeResentCheckEmail:
    'A new verification code was sent to your email. Enter the latest code below.',
  verificationCodeSent: 'Se ha enviado un código de verificación a',
  viewAnswerChoices: 'Ver opciones de respuesta',
  vocabulary_tip: 'Consejo de vocabulario',
  waitingForStudentsDescription: '¡Podrás verlos justo después de que se sumen a la plataforma!',
  waitingForStudentsToJoin: '¡Esperando que tus estudiantes se unan!',
  warningTemporaryPassword: 'Ten en cuenta que la contraseña temporal será válida durante 7 días.',
  weAreAnalyzing: 'Estamos analizando su escritura. Solo unos segundos...',
  weCouldNotProduce: 'No hemos podido elaborar el informe por el momento.',
  weStillDontHaveAll: 'Todavía no tenemos toda la información necesaria o hay un fallo temporal.',
  we_want_to_know: 'Queremos saber tu nivel',
  wednesdayShort: 'mié',
  welcome: '¡Le damos la bienvenida',
  welcomeConfetti: '¡Le damos la bienvenida',
  welcomeTo: 'Le damos la bienvenida a',
  wellDone: 'Bien hecho',
  wordCount: 'Número de palabras: {{wordCount}}',
  words: 'Aprende inglés',
  wordsList: 'Lista de palabras',
  wow: 'Guau',
  wow_score_all_stars:
    '¡Guau! Conseguiste un puntaje de <b>{{score}} </b> y ganaste todas las estrellas.',
  writeClassNameHere: 'Escribe el nombre aquí',
  writeHere: 'Escribe aquí',
  writeOrSay: 'Escribe o di tu respuesta aquí...',
  wrongAnswer: '¡Respuesta incorrecta!',
  yes: 'Sí',
  yesDelete: 'Sí, borrar.',
  youAlmostThere: '¡Ya casi está!',
  youAreDoingGreatLetsKeepGoing: '¡Lo estás haciendo muy bien!<br/> Sigamos adelante.',
  youAreOnYourWay: '¡Estás en camino!',
  youCanCreateMore: 'Puede crear más de una clase',
  youCanPractice: 'puedes practicar palabras mediante juegos o utilizando tarjetas y una lista.',
  youHaveCompleted: '¡Has completado el tema!',
  youMayNowShare: 'Ya puede compartir este enlace con sus ',
  youPassedTheQuiz: '¡Has aprobado la actividad con un puntaje de <b>{{score}}</b>! ¡Buen trabajo!',
  youPracticed: 'Has practicado. Has estudiado.',
  youWillLose: 'Vas a perder',
  you_did_it: '¡Lo lograste!',
  you_got_a_score_try_again:
    'Has conseguido un puntaje de <b>{{score}} </b> esta vez. Vuelve a intentarlo más tarde para ganar más estrellas.',
  you_got_no_extra_stars: 'Obtuviste <b>{{score}} </b> otra vez.',
  your: 'Sus',
  yourClasses: 'Clases',
  yourMessageHasBeenSentSuccessfully:
    'Tu mensaje se ha enviado correctamente. ¡Gracias por tomarte el tiempo para enviarnos tus valiosos comentarios!',
  yourMessageHere: 'Tu mensaje aquí',
  yourPasswordHere: 'Tu contraseña aquí',
  yourPhoneHere: 'Tu teléfono aquí',
  yourSchoolHasBeenCreated: 'Su escuela se ha creado correctamente',
  yourStreak: 'Tu racha',
  yourStudentQuiz:
    'Este es la prueba que sus estudiantes realizarán cuando ingresen a la aplicación por primera vez. Pruébela ahora o puede intentarlo más tarde.',
  yourStudentsHaveNotJoined: 'Aún no hay estudiantes activos',
  yourSubjectHere: 'Tu asunto aquí',
};
